import { coerceNumberProperty } from '@angular/cdk/coercion';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { Message, SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { UnitTreeNode } from '../../../masterscreen/model/unit-tree.model';
import { MasterscreenService } from '../../../masterscreen/services/masterscreen.service';
import { Login } from '../../../observation/model/login.model';
import { SearchText } from '../../../observation/model/searchTexts.model';
import { User } from '../../../observation/model/user.model';
import { ObservationService } from '../../../observation/services/observation.service';
import { ActivityMatrixItem } from '../../../shared/models/activityMatrixItem';
import { FileAttachment } from '../../../shared/models/file-attachment.model';
import { UserPermissionParameters } from '../../../shared/models/user.model';
import { BaseService } from '../../../shared/services/base.service';
import { CommonService } from '../../../shared/services/common.service';
import { HseErrorHandlerService } from '../../../shared/services/hse-error-handler.service';
import { NotificationsService } from '../../../shared/services/notification.service';
import { FileUtility } from '../../../shared/utility/file.utility';
import { AllTableRecordType, ApprovalType, PermitStatus, PermitToWorkConstantsService, PermitType } from '../../services/permittowork-constants.service';
import { PermitToWorkService } from '../../services/permittowork.service';
import { CertificateData } from '../model/certificateData';
import { PTWApprovals } from '../model/PTWApprovals.model';
import { PTWDialog } from '../model/PTWDialog.model';
import { PTWGasTestRecord } from '../model/PTWGasTestRecord.model';
import { PTWPermission } from '../model/PTWPermission.model';
import { PTWPermissionDetails } from '../model/PTWpermissiondetails.model';
import { PTWTablesRecords, TRICRecords } from '../model/PTWTablesRecords.model';
import { ConstantsService } from "./../../../shared/services/constants.service";
import { ObservationConstantsService } from "../../../observation/services/observation-constants.service";

import {
  UserLogInActivity,
  
} from "../../../shared/models/user.model";


@Component({
  selector: 'ara-raise-permit',
  templateUrl: './raise-permit.component.html',
  styleUrls: ['./raise-permit.component.css']
})
export class RaisePermitComponent implements OnInit, OnDestroy {

  ActivityDataSub: Subscription;
  SubActivityDataSub: Subscription;
  permitType: SelectItem[];
  zoneOfWork: SelectItem[];
  hazardousZones: SelectItem[];
  hazardousZonesDropdown: { label: string; value: string; }[];
  activityList: SelectItem[] = [];
  subActivityList: SelectItem[] = [];
  activityMatrixList: ActivityMatrixItem[] = [];
  permitNumber: string;
  routesFlag: { routeName: string; routeURL: string; isClickable: boolean; }[];
  reportRoutes: { routeName: string; routeURL: string; isClickable: boolean; }[];
  value: string;
  unitTree: UnitTreeNode[];
  gasTestRecords: PTWGasTestRecord[] = [];
  allTablesRecords: PTWTablesRecords[] = [];
  allTablesEmitedRecords: PTWTablesRecords[] = [];
  TRICTablesEmitedRecords: TRICRecords[] = [];
  clonedProducts: { [s: string]: PTWGasTestRecord; } = {};
  selectedPermitType: string;
  selectedZone: string;
  selectedHazardousZone: string;
  selectedActivity: string;
  selectedSubActivity: string;
  login: Login;

  PTWForm: FormGroup;
  locations: SelectItem[];
  selectedLocation: any;
  userPermissions: UserPermissionParameters = new UserPermissionParameters();
  loggedInUserJSON: any;
  PTWPermission: PTWPermissionDetails;
  PTWId: number = 0;
  disablePTW: boolean = false;
  PTWLoaded: boolean;

  moduleList: any;
  moduleId: any;
  unitList: any;
  selectedUnit: any;
  company: any;
  isDisplaySpilldetails: boolean;
  display: boolean = true;
  selectedPTWCategoryId: number[];
  userResults: User[] = [];
  searchTexts: SearchText;
  selectedUserEmp: any;
  employee: any[] = [];
  isOtherChecked: boolean;
  isHydrocarbonChecked: boolean;
  isH2SChecked: boolean;
  isOxygenChecked: boolean;
  checkListDetails: any;
  ActivityId: number;
  activitiesCheckList: any;
  activityListDropdown: { label: string; value: string; }[];
  selected: string;
  UnitName: string;
  ActivityName: any;
  UnitId: string;
  year: number;
  dialogHeight: string;
  dialogWidth: string;
  PTWDialogModel: PTWDialog = new PTWDialog()
  values: any;
  permitTypeDropdown: { label: string; value: string; }[];
  permissions: PTWPermission = new PTWPermission();
  ptwPermissions: PTWPermission = new PTWPermission();
  incidentLoaded: boolean;
  UserId: any;
  SelectedUserId: any;
  disablePermit: boolean;
  ActivityMatrix: any[];
  permit: string;
  IsGasRecordAdded: boolean = false;
  isUpdateAllowed: boolean = false;
  ActivityValue: number;
  allSubActivities: any;
  Certificates: CertificateData[] = [];
  sub: any;
  permitId: number = 0;
  unitId: number = 0;
  ptwRequest: any;
  allUsers: any;
  SelectedContractor: any;
  isUpdate: boolean = false;
  currentDate = new Date();
  fromDateOfPermit = new Date();
  tillToDateForRS = new Date();
  tillToDateForWSS = new Date();
  tillToDateForDuration = new Date();
  user: any;
  nameRS: string;
  designationRS: string;
  namePS: string;
  designationPS: string;
  designationExtension: string;
  nameExtension: string;
  showblockPS: boolean = false;
  showblockRS: boolean = false;
  showblockExtension: boolean = false;
  maxDateForExtension: Date;
  minDateForExtension: Date;
  requiredCertificates: number[];
  isAllValid: boolean = true;
  isCertificateApproved: boolean = false;
  allUsersData: SelectItem[] = [];
  SafetyEnvironmentPlanFiles: FileAttachment[] = [];
  VehicleEntryChecklistFiles: FileAttachment[] = [];
  invalidVehicleEntry: boolean = false;
  invalidEnvironmentPlan: boolean = false;
  oncomingHoldersIds: number[] = [];
  gasTestLastRecordId: any;
  allTablesLastRecordId: number = 1;
  TRICTableLastRecordId: number = 1;
  emptyRecordType: number = 0;
  permitStatus: number;
  isOncomingUserAndApplicant: boolean = false;
  isOncomingUser: boolean = false;
  showOtherTables: boolean = false;
  isApplicant: boolean = false;
  showApproveCancelation: boolean = false;
  nameCanclePermitHolder: string;
  designationCanclePermitHolder: string;
  dateCanclePermitHolder: Date;
  statusApplyCanclePermit: string;
  nameCanclePermitAA: any;
  designationCanclePermitAA: any;
  vehicleNote: Message[] = [{ severity: "info", summary: 'Note : Vehicle Access is subject to a satisfactory gas test being carried out on each occasion, with the result recorded in box. Results for Confined Space Entry to be recorded on Certificate, NOT HERE.' }];
  AgreeFrozenPlan: Message[] = [{ severity: "info", summary: 'I have reviewed the task and am satisfied that the information in this Application and in the Job HSE Plan is adequate and correct.' }];
  additionalComments: string;
  activityMatrixId: number;
  isPermitJob: boolean = true;
  IsDirectNoPermitJob: boolean = false;
  permitClassName: string;
  permitIndex: number = -1;
  permitIds: any[] = [];
  isNext: boolean = true;
  isPrevious: boolean = true;
  ApprovalType = ApprovalType;
  AllTableRecordType = AllTableRecordType;
  PermitStatus = PermitStatus;
  TRICTableRecords: TRICRecords[] = [];
  IsTRICTableRecords: boolean = false;
  AttendeeTableLastRecordId: number = 1;
  showTRICTalkTable: boolean = false;
  applicantName: string;
  applicantDesignation: string;
  applicantTelNo: string;
  permitDate: Date = new Date();
  approvalPS: any;
  approvalRS: any;
  approvalExtension: any;
  showSafetyTable: boolean = false;
  TRICRecords: PTWTablesRecords;
  SafetyRecords: PTWTablesRecords[] = [];
  ValidationRecords: PTWTablesRecords[] = [];
  AcceptanceRecords: PTWTablesRecords[] = [];
  SuspensionRecords: PTWTablesRecords[] = [];
  applyCancelation: any;
  approvalCancelation: any;
  OAFRecords: PTWTablesRecords[] = [];
  duplicatePermitDialog: boolean;
  dialogType: string;
  alertType: string;
  successDetails: string;
  ErrorDetails: string;
  errorDetails: string = "";
  confirmMessage: string;
  independentPermissions: any;
  currentFileUrl: string;
  isPermitTypeDecided: boolean = false;
  OAFRecordsUserList: number[] = [];
  isGasTestVisible: boolean = false;
  gasRecordInitialText: string;

  selectedContract: number = 0;
  //BOC Pritesh
  dialog1Height: string;
  dialog1Width: string;
  ReportUserId : number;
  ReportModule : string;
  ReportRecordId : number;
  ReportProcessId : number = 0;
  ReportclosePopup: boolean = false;

  updateActionTrack: any[];
  retVal: boolean;
  userActivityList: UserLogInActivity[] = [];
  url: any;
  url1: any;
  locationDet:any;
  oldPTWCertificates: any[];
  oldPTWgasTestRecords: any[];
  userActivityListForInternalUpdate: UserLogInActivity[] = [];
  oldPTWOAFRecords: any[];
  oldPTWAuthorizationData : any;
  userActivityListForApproval:UserLogInActivity[] = [];
  oldPTWTRICTableRecords : any[];
  oldPTWSafetyRecords : any[];
  oldPTWValidationRecords : any[];
  oldPTWAcceptanceRecords : any[];
  oldPTWSuspensionRecords : any[];
  IsPTWOAFRecordsEdited : boolean = false;
  IsPTWSafetyRecordsEdited : boolean = false;
  IsPTWValidationRecordsEdited : boolean = false;
  IsPTWAcceptanceRecordsEdited : boolean = false;
  IsPTWSuspensionRecordsEdited : boolean = false;
  IsPTWTRICRecordsEdited : boolean = false;
  isInactiveLocation: boolean = false;
  //EOC Pritesh
  editEnabled: boolean = true;
  IsNewRecord:boolean = true;
  
  contracts: { label: string; value: string }[] = [];
  unitContractDetails: any[] = [];
  isHasContractDetails: boolean = true;
  isContractErrorMsg: boolean = true;
  isEmployeeUnit:boolean=true;
  isContractHolder: boolean = false;


  constructor(private baseService: BaseService, private translate: TranslateService,
    private formBuilder: FormBuilder, private observationService: ObservationService, private hseErrorHandler: HseErrorHandlerService,
    private notificationsService: NotificationsService, private commonService: CommonService,
    private masterscreenService: MasterscreenService, private PTWService: PermitToWorkService,
    private route: ActivatedRoute, private router: Router,) {

    this.searchTexts = new SearchText();
    this.baseService.translatorListener.subscribe((data) => {
      this.translate.use(data);
      this.login = new Login();
    });

    this.hazardousZonesDropdown = [
      { label: 'Hazardous Zone 1', value: '1' },
      { label: 'Hazardous Zone 2', value: '2' },
      { label: 'Non Hazardous Zone', value: '3' },
    ];


  }

  expandParents(node) {
    if (node.parent) {
      node.parent.expanded = true;
      this.expandParents(node.parent);
    }
  }

  getcompany() {
    this.baseService.showRootLoader = true;
    if (this.login) {
      const apiRequest = {
        Model: this.login
      };
      this.observationService.getCompanyData(
        apiRequest,
        this.callbackMethodForgetCompanyData.bind(this)
      );
    }
    this.baseService.showRootLoader = false;
  }

  callbackMethodForgetCompanyData(response) {
    this.baseService.showRootLoader = false;
    if (response === undefined) {
      this.serviceError();
    }
    if (response.Success) {
      this.company = response.Result;
    } else {
      this.baseService.showRootLoader = false;
    }
    if (
      response.Result.CompanyName === PermitToWorkConstantsService.CompanyConst.QAMP
    ) {
      this.isDisplaySpilldetails = true;
    }
    if (
      this.company.CompanyName === PermitToWorkConstantsService.CompanyConst.QAMP
    ) {
      this.selectedPTWCategoryId = [2];
    } else {
      this.selectedPTWCategoryId = [1];
    }
    if (response.Result.CompanyId === 0) {
      
    }
    this.baseService.showRootLoader = false;
  }

  compareTreeNode(node, selectedNode) {
    var isFound: boolean = false;
    this.unitList.forEach(element => {
      if (element.UnitId === node.UnitId) {
        isFound = true;
      }
    });
    if (!isFound || !node.IsActive) {
      node.selectable = false;
      node.expanded = false;
    }
    if (node.ParentId !== 0) {
      node.expanded = false;
    }
    if (node.UnitId === selectedNode) {
      this.selectedUnit = node;
      this.expandParents(this.selectedUnit);
    }
    if (node.children && node.children.length > 0) {
      node.selectable = false;
      node.children.forEach(element => {
        var isFound: boolean = false;
        this.unitList.forEach(unit => {
          if (unit.UnitId === element.UnitId) {
            isFound = true;
          }
        });
        if (!isFound || !element.IsActive) {
          element.selectable = false;
          element.expanded = false;
        }
        if (element.ParentId !== 0) {
          element.expanded = false;
        }
        if (element.UnitId === selectedNode) {
          this.selectedUnit = element;
          this.expandParents(this.selectedUnit);
        }
        if (element.children && element.children.length > 0) {
          this.compareTreeNode(element, selectedNode);
        }
      });
    }
  }

  callbackMethodForUnitDetails(response) {
    if (response.Success) {
      this.unitList = response.Result;
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          GetActiveNodes: this.IsNewRecord,
          UserId: this.loggedInUserJSON.UserId
        }
      };
      this.masterscreenService.getTreeData(
        apiRequest,
        this.callbackMethodForGetTreeData.bind(this)
      );
    }
  }

  callbackMethodForGetTreeData(response) {
    if (response.Result !== null) {
      this.unitTree = response.Result;
      if (this.PTWId === 0) {
        this.unitTree.forEach(element => {
          this.compareTreeNode(element, 0);
        });
        this.getPermissions(this.unitId);
      }
    }
    this.getcompany();
    this.login = new Login();
    this.login.CompanyId = this.loggedInUserJSON.Company.CompanyId;
    this.login.ID = this.loggedInUserJSON.UserId;
    this.GetActivities();
    this.GetHazardousAreas();
    this.ShowDialog();
    this.GetActivityMatrix();
    this.GetRecordsForAllTables();
    this.GetTRICTableRecords();
    this.setUsersData();
  }

  getPermissions(unitId) {
    let userPermissionParams: UserPermissionParameters = new UserPermissionParameters();
    userPermissionParams.UserId = this.loggedInUserJSON.UserId;
    userPermissionParams.ModuleId =
      ConstantsService.PermissionMatrixModules.PTW;
    userPermissionParams.UnitId = this.permitId > 0 ? unitId : this.loggedInUserJSON.UnitId;;
    const apiRequest = {
      Model: userPermissionParams,
    };
    this.commonService.getPermissionDetailsForUser(
      apiRequest,
      this.callbackMethodForUserPermissions.bind(this)
    );
  }

  callbackMethodForUserPermissions(response) {
    if (response.Success) {
      this.permissions = new PTWPermission();
      this.permissions = response.Result.PTWPermission;

      if (
        !this.permissions.PTW_Add &&
        !this.permissions.PTW_Add_Unit &&
        !this.permissions.PTW_Admin &&
        !this.permissions.PTW_Admin_Unit
      ) {
        this.routesFlag.find(s => s.routeName == "Apply Permit").isClickable = false;
      }
      if (
        !this.permissions.PTW_Add &&
        !this.permissions.PTW_Add_Unit &&
        !this.permissions.PTW_Admin &&
        !this.permissions.PTW_Admin_Unit
      ){
      this.isUpdateAllowed = false;
      }
      else{
        this.isUpdateAllowed = true;
      }
      if(!this.permissions.PTW_Admin && !this.permissions.PTW_Admin_Unit && !this.permissions.PTW_Responsible_Supervisor && !this.permissions.PTW_Responsible_Supervisor_Unit){
        this.nameRS = "";
        this.designationRS = "";
        this.designationExtension = "";
        this.nameExtension = "";
      }else{
        this.nameRS = this.loggedInUserJSON.FullName;
        this.designationRS = this.loggedInUserJSON.Designation;
        this.designationExtension = this.loggedInUserJSON.Designation;
        this.nameExtension = this.loggedInUserJSON.FullName;
      }
      if(!this.permissions.PTW_Admin && !this.permissions.PTW_Admin_Unit && !this.permissions.PTW_Production_Supervisor && !this.permissions.PTW_Production_Supervisor){
        this.namePS = "";
        this.designationPS = "";
      }else{
        this.namePS = this.loggedInUserJSON.FullName;
        this.designationPS = this.loggedInUserJSON.Designation;
      }
    }
  }
  
  getIsActiveUnit(unitId) {
    
    const apiRequestUnit = {
      Model: {
        UnitId: unitId,  
      },
    };
    this.masterscreenService.getIsActiveUnit(
      apiRequestUnit,
      this.callbackMethodForgetIsActiveUnit.bind(this)
    );
  }

  callbackMethodForgetIsActiveUnit(response) {

    this.editEnabled = response.Result[0]?.IsActive;
    
  }
  getLocation() {
    if (this.login) {
      this.login.UnitId = this.selectedUnit.UnitId;
      const apiRequest = {
        Model: {
          ...this.login,
          GetActiveLocations: this.permitId == 0 ? true : false
        }
      };
      this.observationService.getLocationData(
        apiRequest,
        this.callbackMethodForGetLocationData.bind(this)
      );
    }
  }

  callbackMethodForGetLocationData(response) {
    if (response === undefined) {
      this.serviceError();
    }
    if (response.Success) {
      this.locations = [];

      this.locationDet=response.Result;

      const locationDetails = response.Result;
      locationDetails.forEach(location => {
        this.locations.push({
          label: location.LocationName,
          value: location.LocationId,
          InActive :location?.InActive
        });
        if (location.LocationId === this.PTWForm.value.unitLocation) {
          this.ptwRequest.PTWRequestDetails.LocationId = location.LocationId;
          this.isInactiveLocation = (location?.InActive === true)? true:false;
        }
      });
    }
    if (response.Errors !== null) {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Location list is empty."
      );
      this.hseErrorHandler.handleError(response.Errors);
    }
    this.baseService.showRootLoader = false;
  }
  saveLocation() {
    
    this.locations.forEach((location) => {
      if (location.value === this.PTWForm.value.unitLocation) {
       // this.PTWForm.value.unitLocation = location.value;
        this.isInactiveLocation = (location?.InActive === true)? true:false;
      }
    });
    
  }
  serviceError() {
    this.hseErrorHandler.handleError(
      "Service (WebAPI) is not available or not in running mode"
    );
  }

  getPermissionDetails(unitId) {
    this.userPermissions.ModuleId =
      ConstantsService.PermissionMatrixModules.PTW;
    this.userPermissions.UserId = this.loggedInUserJSON.UserId;
    this.userPermissions.UnitId = unitId;
    const apiRequest = {
      Model: this.userPermissions
    };
    this.commonService.getPermissionDetailsForUser(
      apiRequest,
      this.callbackMethodForgetPermissionDetails.bind(this)
    );
    

  }

  callbackMethodForgetPermissionDetails(response) {
    const permissions = response.Result;
    if (response.Result) {
      this.PTWPermission = permissions.PTWPermission;
      if ((this.ptwRequest.PTWRequestDetails.Status === PermitStatus.Cancel || this.ptwRequest.PTWRequestDetails.Status === PermitStatus.Cancelled || this.ptwRequest.PTWRequestDetails.Status === PermitStatus.Deleted || this.ptwRequest.PTWRequestDetails.Status === PermitStatus.Expired) && (!this.PTWPermission.PTW_Admin || !this.PTWPermission.PTW_Admin_Unit)) {
        this.disablePTW = true;
      }
      else {
        this.disablePTW = false;
      }
    }
    this.baseService.showRootLoader = false;
    this.getAllModules();
  }

  getAllModules() {
    this.masterscreenService.getAllModules(
      null,
      this.callbackMethodForGetAllModules.bind(this)
    );
  }

  callbackMethodForGetAllModules(response) {
    if (response.Success) {
      this.moduleList = response.Result;
      this.moduleList.forEach(element => {
        if (element.ModuleName === "PTW") {
          this.moduleId = element.ModuleId;
        }
      });
    }
    // this.ptwRequest.PTWRequestDetails.location.LocationName=
    // this.locationDet.find(x=>x.LocationId===this.selectedLocation).LocationName;
    
    // this.updateActionTrack = JSON.parse(
    //   this.masterscreenService.getUpdatedData("UpdateAction")
    // );
  }

  nodeSelected(event) {
    this.PTWForm.value.SelectedUnit = event.node;
    if (this.PTWForm.value.SelectedUnit.children && this.PTWForm.value.SelectedUnit.children.length > 0) {
      this.PTWForm.value.SelectedUnit.expanded = true;
    }
    this.PTWForm.patchValue({ SelectedUnit: this.selectedUnit });
    this.getLocation();
    this.decidePermitType();
    this.isEmployeeUnit=true;
    if(event.node.UnitTypeId == 2)
    {
      this.isEmployeeUnit=false;
      this.getContractDetails(this.selectedUnit.UnitId);
    }
  }
  getContractDetails(unitId: number): void {
    const apiRequestUnit = {
      Model: {
        "UnitId": unitId
      },
    };
    this.masterscreenService.getContractDetailsData(
      apiRequestUnit,
      this.callbackMethodForContractDetails.bind(this)
    );
  }
  callbackMethodForContractDetails(response) {
     
  //
    this.contracts = [];
    this.unitContractDetails = response;
    let contractHolderId;
    response.forEach(contract => {
      this.contracts.push({ label: contract.ContractNumber, value: contract.UnitContractDetailsId });
    });
    if (this.permitId !== 0 && this.permitId && this.contracts.some(c => c.value == this.ptwRequest.PTWRequestDetails.ContractId )) {
      let currentContract = this.contracts.find(c => c.value === this.ptwRequest.PTWRequestDetails.ContractId );
      this.PTWForm.patchValue({ Contract: currentContract.value });
      this.checkHolder(currentContract);
      contractHolderId = response.find(h => h.UnitContractDetailsId === this.ptwRequest.PTWRequestDetails.ContractId ).ContractHolderId
      

      this.isContractHolder = contractHolderId === this.loggedInUserJSON.UserId ? true : false;

      
    }
  }
  checkHolder(event) {
    
    let contract;
    contract = this.unitContractDetails.find(contract => contract.UnitContractDetailsId === event.value);
    if (contract.ContractHolderId && contract.ContractNumber != '') {
      this.isHasContractDetails = true;
    } else {
      this.isHasContractDetails = false;
    }
  }

  updatePermit() {
    if (this.permissions.PTW_Admin || this.permissions.PTW_Admin_Unit) {
      this.dialogType = "AdminUpdatePermit";
      this.alertType = "Confirm"
      this.confirmMessage = "Updating the Permit will delete all the approvals and other records associated"
    }
    else {
      this.submitApplyPermit();
    }
   
  }

  submitApplyPermit() {
    
    this.baseService.showRootLoader = true;
    this.Certificates.forEach(element => {
      if (element.IsRequired == true && element.Files.length == 0) {
        this.Certificates[this.Certificates.findIndex(s => s.CertificateType == element.CertificateType)].UploadRequired = true;
      }
      else {
        this.Certificates[this.Certificates.findIndex(s => s.CertificateType == element.CertificateType)].UploadRequired = false;
      }
      if (element.IsApproved == false && (element.Remarks == "" || element.Remarks == undefined) && element.Files.length > 0) {
        this.Certificates[this.Certificates.findIndex(s => s.CertificateType == element.CertificateType)].RemarkRequired = true;
      }
      else {
        this.Certificates[this.Certificates.findIndex(s => s.CertificateType == element.CertificateType)].RemarkRequired = false;
      }
    });

    if (this.Certificates.find(s => s.RemarkRequired == true)) {
      this.isAllValid = false
    }
    else if (this.Certificates.find(s => s.UploadRequired == true)) {
      this.isAllValid = false;
    }
    else if(!this.PTWForm.value.oncomingHolders && this.isPermitJob){
      this.isAllValid = false;
    }
    else if ((this.VehicleEntryChecklistFiles.length <= 0 && this.isPermitJob && this.PTWForm.value.IsVehicleRequired == "true") || this.SafetyEnvironmentPlanFiles.length <= 0) {
      if (this.VehicleEntryChecklistFiles.length <= 0 && this.isPermitJob && this.PTWForm.value.IsVehicleRequired == "true") {
        this.invalidVehicleEntry = true;
        this.isAllValid = false;
      }
      if (this.SafetyEnvironmentPlanFiles.length <= 0) {
        this.invalidEnvironmentPlan = true;
        this.isAllValid = false;
      }
    }
    else {
      this.invalidVehicleEntry = false;
      this.invalidEnvironmentPlan = false;
      this.isAllValid = true;
    }
    if (this.PTWForm.valid && this.isAllValid) {
      const apiRequest = {
        Model: {
          PTWRequestPostDetails: {
            "PermitId": this.permitId,
            "UnitId": this.selectedUnit.UnitId,
            "PermitType": this.permit,
            "LocationId": this.PTWForm.value.unitLocation,
            "Activity": this.PTWForm.value.SelectedSubActivity,
            "ProcessFacility": this.PTWForm.get('IsProcessFacility').value,
            "HydrocarbonArea": this.PTWForm.get('IsHydrocarbonArea').value,
            "HazardousArea": this.PTWForm.get('HazardousZones').value ? this.PTWForm.get('HazardousZones').value.map(Number) : [0],
            "GasTestrequiredBeforeWorkStart": this.PTWForm.get('IsGasTestBeforeAfterDay').value,
            "GasTestrequiredEveryTwoHr": this.PTWForm.get('IsGasTestEveryTwoHour').value,
            "GasMonitoringRequired": this.PTWForm.get('IsContinueGasMonitoring').value,
            "SafetyEquipmentRequired": this.PTWForm.get('IsSafetyEquipment').value,
            "GasTestInterval": this.PTWForm.value.GasTestInterval,
            "AdditionalComment": this.PTWForm.get('AdditionalComments').value,
            "PermitNumber": this.PTWForm.value.PTWNumber,
            "ExactLocation": this.PTWForm.value.ExactLocation,
            "WorkSite": this.PTWForm.value.Worksite,
            "WorkDescription": this.PTWForm.value.WorkDescription,
            "NORMContaminatedArea": this.PTWForm.value.IsNORMContaminatedArea,
            "MercuryPotential": this.PTWForm.value.IsMercuryPotential,
            "H2SFacilityClassification": this.PTWForm.value.H2SFacilityClassification,
            "ExpectedMaxPPM": this.PTWForm.value.ExpectedMaxPPM,
            "AssociatedPTWNo": this.PTWForm.value.AssociatedPTWno,
            "WorkOrderNumber": this.PTWForm.value.EWPno,
            "GasHydrocarbon": this.PTWForm.value.GasTestedForHC,
            "GasH2S": this.PTWForm.value.GasTestedForH2S,
            "GasOxygen": this.PTWForm.value.GasTestedForO2,
            "Other": this.PTWForm.value.GasTestedForOther ? this.PTWForm.value.GasTestSpecify : "",
            "VehicleEntryRequired": this.PTWForm.value.IsVehicleRequired,
            "VehicleAccessPlanApproved": this.PTWForm.value.IsVehicleApproved,
            "PermittedVehicleType": this.PTWForm.value.VehicleType,
            "PermittedVehicleLocation": this.PTWForm.value.Location,
            "AgreesFrozenPlan": this.PTWForm.value.IsAgreeFrozenPlan,
            "ApplicantName": this.loggedInUserJSON.UserId,
            "ApplicantContractor": this.PTWForm.value.ContractorName.UserId,
            "PermitDurationFrom": this.PTWForm.value.DateFrom,
            "PermitDurationTo": this.PTWForm.value.DateTo,
            "WorkExaminationFirstDay": this.PTWForm.value.IsWorkExaminationFirstDay,
            "ValidatorEveryday": this.PTWForm.value.IsValidatorEveryday,
            "CreatedDate": moment(moment.utc(this.currentDate)).toDate(),
            "CreatedBy": this.loggedInUserJSON.UserId,
            "ModifiedDate": moment(moment.utc(this.currentDate)).toDate(),
            "ModifiedBy": this.loggedInUserJSON.UserId,
            "oncomingHolders": this.PTWForm.value.oncomingHolders ? this.PTWForm.value.oncomingHolders : [0],
            "SafetyEnvironmentPlan": this.SafetyEnvironmentPlanFiles,
            "VehicleEntryChecklist": this.VehicleEntryChecklistFiles,
            "IsDraft":false,
            "ContractId" : this.PTWForm.get('Contract').value ? this.PTWForm.get('Contract').value : 0
            
          },
          Certificates: this.Certificates
        }
      };
     
      this.PTWService.savePTWRequests(apiRequest, this.callbackMethodForSavePTWRequests.bind(this));
    }
    else {
      this.baseService.showRootLoader = false;
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "something went wrong!Please fill in all Mandatory fields"
      );
    }
  }

  callbackMethodForSavePTWRequests(response) {
    if (response && response.Success) {
      if (this.isUpdate) {
        this.notificationsService.toastNotify(
          "success",
          "Success Message",
          "PTW Request Updated successfully"
        );
        const apiRequest = {
          Model: {
            PTWRequestPostDetails: {
              "PermitId": this.permitId,
              "UnitId": this.selectedUnit.UnitId,
              "PermitType": this.permit,
              "LocationId": this.PTWForm.value.unitLocation,
              "LocationName": this.locations.find(x=>x.value==this.PTWForm.value.unitLocation).label,
              "Activity": this.PTWForm.value.SelectedSubActivity,
              "ProcessFacility": this.PTWForm.get('IsProcessFacility').value,
              "HydrocarbonArea": this.PTWForm.get('IsHydrocarbonArea').value,
              "HazardousArea": this.PTWForm.get('HazardousZones').value ? this.PTWForm.get('HazardousZones').value.map(Number) : [0],
              "GasTestrequiredBeforeWorkStart": this.PTWForm.get('IsGasTestBeforeAfterDay').value,
              "GasTestrequiredEveryTwoHr": this.PTWForm.get('IsGasTestEveryTwoHour').value,
              "GasMonitoringRequired": this.PTWForm.get('IsContinueGasMonitoring').value,
              "SafetyEquipmentRequired": this.PTWForm.get('IsSafetyEquipment').value,
              "GasTestInterval": this.PTWForm.value.GasTestInterval,
              "AdditionalComment": this.PTWForm.get('AdditionalComments').value,
              "PermitNumber": this.PTWForm.value.PTWNumber,
              "ExactLocation": this.PTWForm.value.ExactLocation,
              "WorkSite": this.PTWForm.value.Worksite,
              "WorkDescription": this.PTWForm.value.WorkDescription,
              "NORMContaminatedArea": this.PTWForm.value.IsNORMContaminatedArea,
              "MercuryPotential": this.PTWForm.value.IsMercuryPotential,
              "H2SFacilityClassification": this.PTWForm.value.H2SFacilityClassification,
              "ExpectedMaxPPM": this.PTWForm.value.ExpectedMaxPPM,
              "AssociatedPTWNo": this.PTWForm.value.AssociatedPTWno,
              "WorkOrderNumber": this.PTWForm.value.EWPno,
              "GasHydrocarbon": this.PTWForm.value.GasTestedForHC,
              "GasH2S": this.PTWForm.value.GasTestedForH2S,
              "GasOxygen": this.PTWForm.value.GasTestedForO2,
              "Other": this.PTWForm.value.GasTestedForOther ? this.PTWForm.value.GasTestSpecify : "",
              "VehicleEntryRequired": this.PTWForm.value.IsVehicleRequired,
              "VehicleAccessPlanApproved": this.PTWForm.value.IsVehicleApproved,
              "PermittedVehicleType": this.PTWForm.value.VehicleType,
              "PermittedVehicleLocation": this.PTWForm.value.Location,
              "AgreesFrozenPlan": this.PTWForm.value.IsAgreeFrozenPlan,
              "ApplicantName": this.loggedInUserJSON.UserId,
              "ApplicantContractor": this.PTWForm.value.ContractorName.UserId,
              "PermitDurationFrom": this.PTWForm.value.DateFrom,
              "PermitDurationTo": this.PTWForm.value.DateTo,
              "WorkExaminationFirstDay": this.PTWForm.value.IsWorkExaminationFirstDay,
              "ValidatorEveryday": this.PTWForm.value.IsValidatorEveryday,
              "CreatedDate": moment(moment.utc(this.currentDate)).toDate(),
              "CreatedBy": this.loggedInUserJSON.UserId,
              "ModifiedDate": moment(moment.utc(this.currentDate)).toDate(),
              "ModifiedBy": this.loggedInUserJSON.UserId,
              "oncomingHolders": this.PTWForm.value.oncomingHolders ? this.PTWForm.value.oncomingHolders : [0],
              "SafetyEnvironmentPlan": this.SafetyEnvironmentPlanFiles,
              "VehicleEntryChecklist": this.VehicleEntryChecklistFiles,
              "IsDraft":false,
              
              "ContractId" :this.isEmployeeUnit?0:(this.PTWForm.get('Contract').value ? this.PTWForm.get('Contract').value : 0)
            },
           
          }
        };
        this.updateActionTrack = JSON.parse(
          this.masterscreenService.getUpdatedData("UpdateAction")
        );
        this.oldPTWCertificates = JSON.parse(
          this.masterscreenService.getOldPTWCertificates("oldPTWCertificates")
        );
        this.trackDetails(
          this.updateActionTrack,
         apiRequest.Model.PTWRequestPostDetails,
          "UpdateAction",
          false
        );
      }
      else {
        this.notificationsService.toastNotify(
          "success",
          "Success Message",
          "PTW Request submitted successfully"
        );
      }
      this.router.navigate(["ptw/permit-overview"]);
    } else {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "something went wrong!"
      );
    }
    this.baseService.showRootLoader = false;
  }
  trackDetails(OldValue, NewValue, action, isNew) {
    
     
    //if (this.status1.StatusName === "Open") {
      //isNew = true;
      //OldValue = [];
    //}
      const columnNames = Object.getOwnPropertyNames(NewValue);
      columnNames.forEach(element => {
        if (OldValue.length === 0) {
          this.retVal = false;
          // OldValue = null;
        } else {
          this.retVal = this.commonService.isDataEqual(
            OldValue[element],
            NewValue[element]
          );
        }
        if (this.retVal === false) {
          switch (action) {
            case "UpdateAction":
            if (element === "AccceptDate") {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            }else if (element === "AcceptorDesignation") {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            }else if (element === "AcceptorName") {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            }
            // else if (element === "Activity") {
            //   this.retVal = this.commonService.isDataEqual(
            //     OldValue[element],
            //     NewValue[element]
            //   );
            //   if (this.retVal === false) {
            //     const userLoginActivity = new UserLogInActivity();
            //     userLoginActivity.FieldName = element;
            //     userLoginActivity.OldValue = isNew ? null : OldValue[element];
            //     userLoginActivity.NewValue = NewValue[element];
            //     this.userActivityList.push(userLoginActivity);
            //   }
            // }
            else if (element === "AgreesFrozenPlan") {//radio
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                 
                  userLoginActivity.OldValue = this.changeStatus(
                    OldValue[element]
                  );
                  userLoginActivity.NewValue = this.changeStatus(
                    NewValue[element]
                  );
                if( userLoginActivity.OldValue!=userLoginActivity.NewValue)
                  {this.userActivityList.push(userLoginActivity);
                  }
              }
            }else if (element === "ApplicantContact") {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            }else if (element === "ApplicantContractor") {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            }else if (element === "ApplicantName") {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            }else if (element === "AssociatedPTWNo") {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            }else if (element === "CreatedDate") {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            }else if (element === "ExactLocation") {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            }else if (element === "ExpectedMaxPPM") {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            }else if (element === "ExtensionValidTo") {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            }else if (element === "GasH2S") {//radio
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                 
                  userLoginActivity.OldValue = this.changeStatus(
                    OldValue[element]
                  );
                  userLoginActivity.NewValue = this.changeStatus(
                    NewValue[element]
                  );

                  if( userLoginActivity.OldValue!=userLoginActivity.NewValue)
                  {this.userActivityList.push(userLoginActivity);
                  }
                
              }
            }else if (element === "GasHydrocarbon") {//radio
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                 
                  userLoginActivity.OldValue = this.changeStatus(
                    OldValue[element]
                  );
                  userLoginActivity.NewValue = this.changeStatus(
                    NewValue[element]
                  );

                  if( userLoginActivity.OldValue!=userLoginActivity.NewValue)
                  {this.userActivityList.push(userLoginActivity);
                  }
                
              }
            }else if (element === "GasMonitoringRequired") {//radio
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                 
                  userLoginActivity.OldValue = this.changeStatus(
                    OldValue[element]
                  );
                  userLoginActivity.NewValue = this.changeStatus(
                    NewValue[element]
                  );

                  if( userLoginActivity.OldValue!=userLoginActivity.NewValue)
                  {this.userActivityList.push(userLoginActivity);
                  }
                
              }
            }else if (element === "GasOxygen") {//radio
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                 
                  userLoginActivity.OldValue = this.changeStatus(
                    OldValue[element]
                  );
                  userLoginActivity.NewValue = this.changeStatus(
                    NewValue[element]
                  );

                  if( userLoginActivity.OldValue!=userLoginActivity.NewValue)
                  {this.userActivityList.push(userLoginActivity);
                  }
                
              }
            }else if (element === "GasTestInterval") {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            }else if (element === "GasTestrequiredBeforeWorkStart") {//radio
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                 
                  userLoginActivity.OldValue = this.changeStatus(
                    OldValue[element]
                  );
                  userLoginActivity.NewValue = this.changeStatus(
                    NewValue[element]
                  );

                  if( userLoginActivity.OldValue!=userLoginActivity.NewValue)
                  {this.userActivityList.push(userLoginActivity);
                  }
                
              }
            }else if (element === "GasTestrequiredEveryTwoHr") {//radio
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                 
                  userLoginActivity.OldValue = this.changeStatus(
                    OldValue[element]
                  );
                  userLoginActivity.NewValue = this.changeStatus(
                    NewValue[element]
                  );

                  if( userLoginActivity.OldValue!=userLoginActivity.NewValue)
                  {this.userActivityList.push(userLoginActivity);
                  }
                
              }
            }else if (element === "H2SFacilityClassification") {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            }
            // else if (element === "HazardousArea") {
            //   this.retVal = this.commonService.isDataEqual(
            //     OldValue[element],
            //     NewValue[element]
            //   );
            //   if (this.retVal === false) {
            //     const userLoginActivity = new UserLogInActivity();
            //     userLoginActivity.FieldName = element;
            //     userLoginActivity.OldValue = isNew ? null : OldValue[element];
            //     userLoginActivity.NewValue = NewValue[element];
            //     this.userActivityList.push(userLoginActivity);
            //   }
            // }
            else if (element === "HydrocarbonArea") {//radio
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                 
                  userLoginActivity.OldValue = this.changeStatus(
                    OldValue[element]
                  );
                  userLoginActivity.NewValue = this.changeStatus(
                    NewValue[element]
                  );

                  if( userLoginActivity.OldValue!=userLoginActivity.NewValue)
                  {this.userActivityList.push(userLoginActivity);
                  }
                
              }
            }else if (element === "IsDailyPreValidation") {//radio
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                 
                  userLoginActivity.OldValue = this.changeStatus(
                    OldValue[element]
                  );
                  userLoginActivity.NewValue = this.changeStatus(
                    NewValue[element]
                  );

                  if( userLoginActivity.OldValue!=userLoginActivity.NewValue)
                  {this.userActivityList.push(userLoginActivity);
                  }
                
              }
            }else if (element === "IsHoursValidation") {//radio
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                 
                  userLoginActivity.OldValue = this.changeStatus(
                    OldValue[element]
                  );
                  userLoginActivity.NewValue = this.changeStatus(
                    NewValue[element]
                  );

                  if( userLoginActivity.OldValue!=userLoginActivity.NewValue)
                  {this.userActivityList.push(userLoginActivity);
                  }
                
              }
            }else if (element === "LocationName") {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            }
            // else if (element === "LocationId") {
            //   this.retVal = this.commonService.isDataEqual(
            //     OldValue[element],
            //     NewValue[element]
            //   );
            //   if (this.retVal === false) {
            //     const userLoginActivity = new UserLogInActivity();
            //     userLoginActivity.FieldName = element;
            //     userLoginActivity.OldValue = isNew ? null : OldValue[element];
            //     userLoginActivity.NewValue = NewValue[element];
            //     this.userActivityList.push(userLoginActivity);
            //   }
            // }
            else if (element === "MainActivity") {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            }else if (element === "MercuryPotential") {//radio
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                 
                  userLoginActivity.OldValue = this.changeStatus(
                    OldValue[element]
                  );
                  userLoginActivity.NewValue = this.changeStatus(
                    NewValue[element]
                  );
                  if( userLoginActivity.OldValue!=userLoginActivity.NewValue)
                  {this.userActivityList.push(userLoginActivity);
                  }
              }
            }else if (element === "ModifiedBy") {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            }else if (element === "ModifiedDate") {//
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            }else if (element === "NORMContaminatedArea") {//radio
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                 
                  userLoginActivity.OldValue = this.changeStatus(
                    OldValue[element]
                  );
                  userLoginActivity.NewValue = this.changeStatus(
                    NewValue[element]
                  );

                  if( userLoginActivity.OldValue!=userLoginActivity.NewValue)
                  {this.userActivityList.push(userLoginActivity);
                  }
                
              }
            }else if (element === "Other") {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            }else if (element === "PermitDurationFrom") {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = "PermitDurationRequestedFrom";
                userLoginActivity.OldValue = (OldValue[element] != null && OldValue[element] != "") ? this.getFormattedDate(moment(moment.utc(OldValue[element]).local()).toDate()) : "";
                userLoginActivity.NewValue = (NewValue[element] != null && NewValue[element] != "") ? this.getFormattedDate(moment(moment.utc(NewValue[element]).local()).toDate()) : "";
                this.userActivityList.push(userLoginActivity);
              }
            }else if (element === "PermitDurationTo") {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = "PermitDurationRequestedTo";
                userLoginActivity.OldValue = (OldValue[element] != null && OldValue[element] != "") ? this.getFormattedDate(moment(moment.utc(OldValue[element]).local()).toDate()) : "";
                userLoginActivity.NewValue = (NewValue[element] != null && NewValue[element] != "") ? this.getFormattedDate(moment(moment.utc(NewValue[element]).local()).toDate()) : "";
                this.userActivityList.push(userLoginActivity);
              }
            } else if (element === "PermitId") {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            } else if (element === "PermitNumber") {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            }
            //  else if (element === "PermitType") {
            //   this.retVal = this.commonService.isDataEqual(
            //     OldValue[element],
            //     NewValue[element]
            //   );
            //   if (this.retVal === false) {
            //     const userLoginActivity = new UserLogInActivity();
            //     userLoginActivity.FieldName = element;
            //     userLoginActivity.OldValue = isNew ? null : OldValue[element];
            //     userLoginActivity.NewValue = NewValue[element];
            //     this.userActivityList.push(userLoginActivity);
            //   }
            // } 
            else if (element === "PermittedVehicleLocation") {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            } 
            else if (element === "PermittedVehicleType") {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            } else if (element === "ProcessFacility") {//radio
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                 
                  userLoginActivity.OldValue = this.changeStatus(
                    OldValue[element]
                  );
                  userLoginActivity.NewValue = this.changeStatus(
                    NewValue[element]
                  );

                  if( userLoginActivity.OldValue!=userLoginActivity.NewValue)
                  {this.userActivityList.push(userLoginActivity);
                  }
                
              }
            }else if (element === "SafetyEquipmentRequired") {//radio
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                 
                  userLoginActivity.OldValue = this.changeStatus(
                    OldValue[element]
                  );
                  userLoginActivity.NewValue = this.changeStatus(
                    NewValue[element]
                  );

                  if( userLoginActivity.OldValue!=userLoginActivity.NewValue)
                  {this.userActivityList.push(userLoginActivity);
                  }
                
              }
            }else if (element === "UnitId") {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            }else if (element === "ValidatorEveryday") {//radio
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                 
                  userLoginActivity.OldValue = this.changeStatus(
                    OldValue[element]
                  );
                  userLoginActivity.NewValue = this.changeStatus(
                    NewValue[element]
                  );

                  if( userLoginActivity.OldValue!=userLoginActivity.NewValue)
                  {this.userActivityList.push(userLoginActivity);
                  }
                
              }
            }else if (element === "VehicleAccessPlanApproved") {//radio
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                 
                  userLoginActivity.OldValue = this.changeStatus(
                    OldValue[element]
                  );
                  userLoginActivity.NewValue = this.changeStatus(
                    NewValue[element]
                  );

                  if( userLoginActivity.OldValue!=userLoginActivity.NewValue)
                  {this.userActivityList.push(userLoginActivity);
                  }
                
              }
            } else if (element === "VehicleEntryRequired") {//radio
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                 
                  userLoginActivity.OldValue = this.changeStatus(
                    OldValue[element]
                  );
                  userLoginActivity.NewValue = this.changeStatus(
                    NewValue[element]
                  );

                  if( userLoginActivity.OldValue!=userLoginActivity.NewValue)
                  {this.userActivityList.push(userLoginActivity);
                  }
                
              }
            } else if (element === "WorkDescription") {//
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            } else if (element === "WorkExaminationFirstDay") {//radio
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                 
                  userLoginActivity.OldValue = this.changeStatus(
                    OldValue[element]
                  );
                  userLoginActivity.NewValue = this.changeStatus(
                    NewValue[element]
                  );

                  if( userLoginActivity.OldValue!=userLoginActivity.NewValue)
                  {this.userActivityList.push(userLoginActivity);
                  }
                
              }
            }else if (element === "WorkOrderNumber") {//
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            }else if (element === "WorkSite") {//
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element]
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            }
            else if (element === "SafetyEnvironmentPlan") {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              let SafetyEnvFilePath = "";
              let SafEnvUrl = "";
              if(OldValue[element] != null && OldValue[element] != undefined && OldValue[element].length > 0)
              {
              for (var i = 0; i < OldValue[element].length; i++) {
                  this.url = OldValue[element][i].Name;
                  SafEnvUrl = OldValue[element][i].FilePath;             
                  userLoginActivity.OldValue += this.url + ",";
                  SafetyEnvFilePath += SafEnvUrl + ",";
               }
              }
              else
              {
                userLoginActivity.OldValue = "";
              }
              if(NewValue[element] != null && NewValue[element] != undefined && NewValue[element].length > 0)
              {
               for (var i = 0; i < NewValue[element].length; i++) {
                  this.url1 = NewValue[element][i].Name;
                  userLoginActivity.NewValue += this.url1 + ",";
               }
              }
              else
              {
                userLoginActivity.NewValue = "";
              }
              if( userLoginActivity.OldValue!=userLoginActivity.NewValue)
              {
                userLoginActivity.OldValue = SafetyEnvFilePath;
                this.userActivityList.push(userLoginActivity);
              }
           }  else if (element === "oncomingHolders") {//
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              userLoginActivity.OldValue = isNew ? null : OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            }
          } else if (element === "VehicleEntryChecklist") {//
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            let VehicleEntryOldFilePath = "";
            let VehFilePath = "";
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              if(OldValue[element] != null && OldValue[element] != undefined && OldValue[element].length > 0)
              {
              for (var i = 0; i < OldValue[element].length; i++) {
                  this.url = OldValue[element][i].Name;
                  VehFilePath = OldValue[element][i].FilePath;             
                  userLoginActivity.OldValue += this.url + ",";
                  VehicleEntryOldFilePath += VehFilePath + ",";
               }
              }
              else
              {
                userLoginActivity.OldValue = "";
              }
              if(NewValue[element] != null && NewValue[element] != undefined && NewValue[element].length > 0)
              {
               for (var i = 0; i < NewValue[element].length; i++) {
                  this.url1 = NewValue[element][i].Name;
                  userLoginActivity.NewValue += this.url1 + ",";
               }
              }
              else
              {
                userLoginActivity.NewValue = "";
              }
              if( userLoginActivity.OldValue!=userLoginActivity.NewValue)
              {
                userLoginActivity.OldValue = VehicleEntryOldFilePath;
                this.userActivityList.push(userLoginActivity);
              }
            }
          } else if (element === "ContractId") {//
            this.retVal = this.commonService.isDataEqual(
              OldValue[element],
              NewValue[element]
            );
            if (this.retVal === false) {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = "Contract Number";
              userLoginActivity.OldValue = isNew ? null : OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            }
          } 
             
            // 

            
           }
        }
      });

      // Report Log for Certificates - Start
        let oldValueCount = this.oldPTWCertificates == null ? 0 : this.oldPTWCertificates.length;
        let newValueCount = this.Certificates == null ? 0 : this.Certificates.length;
        let length = oldValueCount > newValueCount ? oldValueCount : newValueCount;
        let Maxcertificates = oldValueCount > newValueCount ? "Old" : "New";
       
        for(var index = 0;index<length;index++)
        {
          let CertificateName = "";
          let oldRequiredCheck = false;
          let currentRequiredCheck = false;
          let oldFiles = "";
          let oldFilesUrl = "";
          let currentFiles = "";
          let oldAccept = false;
          let currentAccept = false;
          let oldRemark = "";
          let currentRemark = "";
          if(Maxcertificates == "Old")
          {
            CertificateName = this.oldPTWCertificates[index].CertificateName;
          }
          else
          {
            CertificateName = this.Certificates[index].CertificateName;
          }
        for(var i=0;i<length;i++)
        {
         
           //Certificate IsRequired
           if (this.oldPTWCertificates[i] != undefined && this.oldPTWCertificates[i].CertificateName == CertificateName) {
            oldRequiredCheck = this.oldPTWCertificates[i].IsRequired;
          } 
          if (this.Certificates[i] != undefined && this.Certificates[i].CertificateName == CertificateName) {
            currentRequiredCheck = this.Certificates[i].IsRequired;
          } 
                
           //Certificate Files
           const userLoginActivity6 = new UserLogInActivity();
        userLoginActivity6.FieldName = "Certificate Files For  " + CertificateName ;
        if (this.oldPTWCertificates[i] != undefined && this.oldPTWCertificates[i].CertificateName == CertificateName && this.oldPTWCertificates[i].Files.length > 0) {
          for (var j = 0; j < this.oldPTWCertificates[i].Files.length; j++) {
            const url = this.oldPTWCertificates[i].Files[j]
              .Name;
            oldFiles += url + ",";
            const filePath = this.oldPTWCertificates[i].Files[j]
            .FilePath;
            oldFilesUrl += filePath + ",";
            
          }
        } 
        if (this.Certificates[i] != undefined && this.Certificates[i].CertificateName == CertificateName && this.Certificates[i].Files.length > 0) {
          for (var j = 0; j < this.Certificates[i].Files.length; j++) {
            const url = this.Certificates[i].Files[j]
              .Name;
            currentFiles += url + ",";
          }
        } 

        // Certificate Approval
        if (this.oldPTWCertificates[i] != undefined && this.oldPTWCertificates[i].CertificateName == CertificateName) {
          oldAccept = this.oldPTWCertificates[i].IsApproved;
        } 
        if (this.Certificates[i] != undefined && this.Certificates[i].CertificateName == CertificateName) {
          currentAccept = this.Certificates[i].IsApproved;
        } 

         // Certificate Remarks
         if (this.oldPTWCertificates[i] != undefined && this.oldPTWCertificates[i].CertificateName == CertificateName) {
          oldRemark = this.oldPTWCertificates[i].Remarks;
        } 
        if (this.Certificates[i] != undefined && this.Certificates[i].CertificateName == CertificateName) {
          currentRemark = this.Certificates[i].Remarks;
        } 

       } 
       if(oldRequiredCheck != currentRequiredCheck)
       {
        this.AddActivityForCertificates("Certificate Required For " + CertificateName,oldRequiredCheck == true ? "True":"False",currentRequiredCheck == true ? "True":"False");
       }  
       if(oldFiles != currentFiles)
       {
        this.AddActivityForCertificates("Certificate Files For " + CertificateName,oldFilesUrl,currentFiles);
       } 
       if(oldAccept != currentAccept)
       {
        this.AddActivityForCertificates("Certificate Approval For " + CertificateName,oldAccept == true ? "Accept":"Reject",currentAccept == true ? "Accept":"Reject");
       }  
       if(oldRemark != currentRemark)
       {
        this.AddActivityForCertificates("Certificate Remark For " + CertificateName,oldRemark,currentRemark);
       } 
      } 
      // Report Log for Certificates - End

      if (this.userActivityList.length > 0) {
        this.commonService.saveUserActivityDetails(
         this.permitId,
          new Date(),
          "PTW",
          this.loggedInUserJSON.UserId,
          this.userActivityList
        );
      }
  }

  trackApprovalDetails(Type,OldValue,NewValue)
  {
    this.userActivityListForApproval = []; 
    if (Type == ApprovalType.ResponsibleSupervisor)
    {
      const userLoginActivity = new UserLogInActivity();
      userLoginActivity.FieldName = "DailyPreValidationAllowed";
      userLoginActivity.OldValue = OldValue.Model.IsDailyValidationAllowed == "true" ? "Yes" : "No";
      userLoginActivity.NewValue = NewValue.IsDailyPreValidation == "true" ? "Yes" : "No";
      if(userLoginActivity.OldValue != userLoginActivity.NewValue)
      {
        this.userActivityListForApproval.push(userLoginActivity);
      }
      const userLoginActivity1 = new UserLogInActivity();
      userLoginActivity1.FieldName = "24HoursValidationAllowed";
      userLoginActivity1.OldValue = OldValue.Model.IsHoursValidationAllowed == "true" ? "Yes" : "No";
      userLoginActivity1.NewValue = NewValue.IsHoursValidation == "true" ? "Yes" : "No";
      if(userLoginActivity1.OldValue != userLoginActivity1.NewValue)
      {
        this.userActivityListForApproval.push(userLoginActivity1);
      }
      const userLoginActivity2 = new UserLogInActivity();
      userLoginActivity2.FieldName = "PermitApprovedFromDate";
      userLoginActivity2.OldValue = (OldValue.Model.PermitApprovedFromDate != undefined && OldValue.Model.PermitApprovedFromDate != null && OldValue.Model.PermitApprovedFromDate != "") ? this.getFormattedDateTime(moment(moment.utc(OldValue.Model.PermitApprovedFromDate).local()).toDate()) : ""; 
      userLoginActivity2.NewValue = (NewValue.PermitApprovedFrom != undefined && NewValue.PermitApprovedFrom != null && NewValue.PermitApprovedFrom != "") ? this.getFormattedDateTime(moment(moment.utc(NewValue.PermitApprovedFrom).local()).toDate()) : "";
      if(userLoginActivity2.OldValue != userLoginActivity2.NewValue)
      {
        this.userActivityListForApproval.push(userLoginActivity2);
      }
      const userLoginActivity3 = new UserLogInActivity();
      userLoginActivity3.FieldName = "PermitApprovedToDate";
      userLoginActivity3.OldValue = (OldValue.Model.PermitApprovedToDate != undefined && OldValue.Model.PermitApprovedToDate != null && OldValue.Model.PermitApprovedToDate != "") ? this.getFormattedDateTime(moment(moment.utc(OldValue.Model.PermitApprovedToDate).local()).toDate()) : ""; 
      userLoginActivity3.NewValue = (NewValue.PermitApprovedTo != undefined && NewValue.PermitApprovedTo != null && NewValue.PermitApprovedTo != "") ? this.getFormattedDateTime(moment(moment.utc(NewValue.PermitApprovedTo).local()).toDate()) : "";
      if(userLoginActivity3.OldValue != userLoginActivity3.NewValue)
      {
        this.userActivityListForApproval.push(userLoginActivity3);
      }
      const userLoginActivity4 = new UserLogInActivity();
      userLoginActivity4.FieldName = "ResponsibleSupervisorRemark";
      userLoginActivity4.OldValue = OldValue.Model.ResponsibleSupervisorRemark == null ? "" : OldValue.Model.ResponsibleSupervisorRemark;
      userLoginActivity4.NewValue = this.PTWForm.value.remarksRS == null ? "" : this.PTWForm.value.remarksRS;
      if(userLoginActivity4.OldValue != userLoginActivity4.NewValue)
      {
        this.userActivityListForApproval.push(userLoginActivity4);
      }
    }
    else if (Type == ApprovalType.Extension)
    {
      const userLoginActivity2 = new UserLogInActivity();
      userLoginActivity2.FieldName = "ExtensionValidUpto";
      userLoginActivity2.OldValue = (OldValue.Model.ExtensionValidUpto != undefined && OldValue.Model.ExtensionValidUpto != null && OldValue.Model.ExtensionValidUpto != "") ? this.getFormattedDateTime(moment(moment.utc(OldValue.Model.ExtensionValidUpto).local()).toDate()) : ""; 
      userLoginActivity2.NewValue = (NewValue.ExtensionValidTo != undefined && NewValue.ExtensionValidTo != null && NewValue.ExtensionValidTo != "") ? this.getFormattedDateTime(moment(moment.utc(NewValue.ExtensionValidTo).local()).toDate()) : "";
      if(userLoginActivity2.OldValue != userLoginActivity2.NewValue)
      {
        this.userActivityListForApproval.push(userLoginActivity2);
      }
      const userLoginActivity4 = new UserLogInActivity();
      userLoginActivity4.FieldName = "ExtensionAuthorizationRemark";
      userLoginActivity4.OldValue = OldValue.Model.ExtensionAuthorizationRemark == null ? "" : OldValue.Model.ExtensionAuthorizationRemark;
      userLoginActivity4.NewValue = this.PTWForm.value.remarksExtension == null ? "" : this.PTWForm.value.remarksExtension;
      if(userLoginActivity4.OldValue != userLoginActivity4.NewValue)
      {
        this.userActivityListForApproval.push(userLoginActivity4);
      }
    }
    else if (Type == ApprovalType.ProductionSupervisor)
    {
      const userLoginActivity4 = new UserLogInActivity();
      userLoginActivity4.FieldName = "ProductionSupervisorRemark";
      userLoginActivity4.OldValue = OldValue.Model.ProductionSupervisorRemark == null ? "" : OldValue.Model.ProductionSupervisorRemark;
      userLoginActivity4.NewValue = this.PTWForm.value.remarksPS == null ? "" : this.PTWForm.value.remarksPS;
      if(userLoginActivity4.OldValue != userLoginActivity4.NewValue)
      {
        this.userActivityListForApproval.push(userLoginActivity4);
      }
    }
    if (this.userActivityListForApproval.length > 0) {
      this.commonService.saveUserActivityDetails(
       this.permitId,
        new Date(),
        "PTW",
        this.loggedInUserJSON.UserId,
        this.userActivityListForApproval
      );
    }
  }

  trackDetailsForInternalUpdate(Type,OldValue,NewValue)
  {
    this.userActivityListForInternalUpdate = []; 
    if(Type == "PTWgasTestRecords")
    {
      let oldValueCount = OldValue == null ? 0 : OldValue.length;
      let newValueCount = NewValue == null ? 0 : NewValue.length;
      let length = oldValueCount > newValueCount ? oldValueCount : newValueCount;
      for(var i=0;i<length;i++)
      {
         //Date Comparison
         const userLoginActivity = new UserLogInActivity();
         userLoginActivity.FieldName = " Gas Test Records - Date " + " " + (i+1);
         userLoginActivity.OldValue = OldValue[i] != undefined ? this.getFormattedDateTime(moment(moment.utc(OldValue[i].date).local()).toDate()) : ""; 
         userLoginActivity.NewValue = NewValue[i] != undefined ? this.getFormattedDateTime(moment(moment.utc(NewValue[i].date).local()).toDate()) : "";
        if(userLoginActivity.OldValue != userLoginActivity.NewValue && !(userLoginActivity.OldValue != "" && userLoginActivity.NewValue != ""))
        {
          this.userActivityListForInternalUpdate.push(userLoginActivity);
        }

         //Result Comparison
         const userLoginActivity1 = new UserLogInActivity();
         userLoginActivity1.FieldName = " Gas Test Records - Result " + " " + (i+1);
         userLoginActivity1.OldValue = OldValue[i] != undefined ? OldValue[i].result : ""; 
         userLoginActivity1.NewValue = NewValue[i] != undefined ? NewValue[i].result : "";
        if(userLoginActivity1.OldValue != userLoginActivity1.NewValue)
        {
          this.userActivityListForInternalUpdate.push(userLoginActivity1);
        }

         //User Comparison
         const userLoginActivity2 = new UserLogInActivity();
         userLoginActivity2.FieldName = " Gas Test Records - User " + " " + (i+1);
         userLoginActivity2.OldValue = OldValue[i] != undefined ? OldValue[i].user : ""; 
         userLoginActivity2.NewValue = NewValue[i] != undefined ? NewValue[i].username : "";
        if(userLoginActivity2.OldValue != userLoginActivity2.NewValue && !(userLoginActivity2.OldValue != "" && userLoginActivity2.NewValue != ""))
        {
          this.userActivityListForInternalUpdate.push(userLoginActivity2);
        }
      }  
        
    }
    else if (Type == "PTWOAFRecords" && this.IsPTWOAFRecordsEdited)
    {
      let oldValueCount = OldValue == null ? 0 : OldValue.length;
      let newValueCount = NewValue == null ? 0 : NewValue.length;
      let length = oldValueCount > newValueCount ? oldValueCount : newValueCount;
      for(var i=0;i<length;i++)
      {
         //Name Comparison
         const userLoginActivityOAC1 = new UserLogInActivity();
         userLoginActivityOAC1.FieldName = " Other Affected Custodian - Name " + " " + (i+1);
         userLoginActivityOAC1.OldValue = OldValue[i] != undefined ? OldValue[i].user : ""; 
         userLoginActivityOAC1.NewValue = NewValue[i] != undefined ? NewValue[i].username : "";
        if(userLoginActivityOAC1.OldValue != userLoginActivityOAC1.NewValue && !(userLoginActivityOAC1.OldValue != "" && userLoginActivityOAC1.NewValue != ""))
        {
          this.userActivityListForInternalUpdate.push(userLoginActivityOAC1);
        }

         //Designation Comparison
         const userLoginActivityOAC2 = new UserLogInActivity();
         userLoginActivityOAC2.FieldName = " Other Affected Custodian - Designation " + " " + (i+1);
         userLoginActivityOAC2.OldValue = OldValue[i] != undefined ? OldValue[i].designation : ""; 
         userLoginActivityOAC2.NewValue = NewValue[i] != undefined ? NewValue[i].designation : "";
        if(userLoginActivityOAC2.OldValue != userLoginActivityOAC2.NewValue && !(userLoginActivityOAC2.OldValue != "" && userLoginActivityOAC2.NewValue != ""))
        {
          this.userActivityListForInternalUpdate.push(userLoginActivityOAC2);
        }

         //Date Comparison
         const userLoginActivity = new UserLogInActivity();
         userLoginActivity.FieldName = " Other Affected Custodian - Date " + " " + (i+1);
         userLoginActivity.OldValue = OldValue[i] != undefined ? this.getFormattedDateTime(moment(moment.utc(OldValue[i].date).local()).toDate()) : ""; 
         userLoginActivity.NewValue = NewValue[i] != undefined ? this.getFormattedDateTime(moment(moment.utc(NewValue[i].date).local()).toDate()) : "";
        if(userLoginActivity.OldValue != userLoginActivity.NewValue && !(userLoginActivity.OldValue != "" && userLoginActivity.NewValue != ""))
        {
          this.userActivityListForInternalUpdate.push(userLoginActivity);
        }

         //Remarks Comparison
         const userLoginActivity1 = new UserLogInActivity();
         userLoginActivity1.FieldName = " Other Affected Custodian - Remarks " + " " + (i+1);
         userLoginActivity1.OldValue = OldValue[i] != undefined ? OldValue[i].Remarks : ""; 
         userLoginActivity1.NewValue = NewValue[i] != undefined ? NewValue[i].Remarks : "";
        if(userLoginActivity1.OldValue != userLoginActivity1.NewValue)
        {
          this.userActivityListForInternalUpdate.push(userLoginActivity1);
        }
      }  
    }
    else if(Type == "PTWTRICTableRecords" && this.IsPTWTRICRecordsEdited)
    {
      let oldValueCount = OldValue == null ? 0 : OldValue.length;
      let newValueCount = NewValue == null ? 0 : NewValue.length;
      let length = oldValueCount > newValueCount ? oldValueCount : newValueCount;
      for(var i=0;i<length;i++)
      {
       //Date Comparison
       const userLoginActivity = new UserLogInActivity();
       userLoginActivity.FieldName = " TRIC Talk - Date " + " " + (i+1);
       userLoginActivity.OldValue = OldValue[i] != undefined ? this.getFormattedDateTime(moment(moment.utc(OldValue[i].date).local()).toDate()) : ""; 
       userLoginActivity.NewValue = NewValue[i] != undefined ? this.getFormattedDateTime(moment(moment.utc(NewValue[i].date).local()).toDate()) : "";
      if(userLoginActivity.OldValue != userLoginActivity.NewValue && !(userLoginActivity.OldValue != "" && userLoginActivity.NewValue != ""))
      {
        this.userActivityListForInternalUpdate.push(userLoginActivity);
      }
       //Name Comparison
       const userLoginActivityOAC1 = new UserLogInActivity();
       userLoginActivityOAC1.FieldName = " TRIC Talk - Name of TBT Leader " + " " + (i+1);
       userLoginActivityOAC1.OldValue = OldValue[i] != undefined ? OldValue[i].user : ""; 
       userLoginActivityOAC1.NewValue = NewValue[i] != undefined ? NewValue[i].username : "";
      if(userLoginActivityOAC1.OldValue != userLoginActivityOAC1.NewValue && !(userLoginActivityOAC1.OldValue != "" && userLoginActivityOAC1.NewValue != ""))
      {
        this.userActivityListForInternalUpdate.push(userLoginActivityOAC1);
      }
       //No of Work Party Comparison
       const userLoginActivity1 = new UserLogInActivity();
       userLoginActivity1.FieldName = " TRIC Talk - No of Work Party " + " " + (i+1);
       userLoginActivity1.OldValue = OldValue[i] != undefined ? OldValue[i].NoOfWorkParty : ""; 
       userLoginActivity1.NewValue = NewValue[i] != undefined ? NewValue[i].NoOfWorkParty : "";
      if(userLoginActivity1.OldValue != userLoginActivity1.NewValue)
      {
        this.userActivityListForInternalUpdate.push(userLoginActivity1);
      }
     }
    }
    else if(Type == "PTWSafetyRecords" && this.IsPTWSafetyRecordsEdited)
    {
      let oldValueCount = OldValue == null ? 0 : OldValue.length;
      let newValueCount = NewValue == null ? 0 : NewValue.length;
      let length = oldValueCount > newValueCount ? oldValueCount : newValueCount;
      for(var i=0;i<length;i++)
      {
        //Name Comparison
        const userLoginActivityOAC1 = new UserLogInActivity();
        userLoginActivityOAC1.FieldName = " Safety Coordination - Name " + " " + (i+1);
        userLoginActivityOAC1.OldValue = OldValue[i] != undefined ? OldValue[i].user : ""; 
        userLoginActivityOAC1.NewValue = NewValue[i] != undefined ? NewValue[i].username : "";
        if(userLoginActivityOAC1.OldValue != userLoginActivityOAC1.NewValue && !(userLoginActivityOAC1.OldValue != "" && userLoginActivityOAC1.NewValue != ""))
        {
          this.userActivityListForInternalUpdate.push(userLoginActivityOAC1);
        }
         //Date Comparison
       const userLoginActivity = new UserLogInActivity();
       userLoginActivity.FieldName = " Safety Coordination - Date " + " " + (i+1);
       userLoginActivity.OldValue = OldValue[i] != undefined ? this.getFormattedDateTime(moment(moment.utc(OldValue[i].date).local()).toDate()) : ""; 
       userLoginActivity.NewValue = NewValue[i] != undefined ? this.getFormattedDateTime(moment(moment.utc(NewValue[i].date).local()).toDate()) : "";
      if(userLoginActivity.OldValue != userLoginActivity.NewValue && !(userLoginActivity.OldValue != "" && userLoginActivity.NewValue != ""))
      {
        this.userActivityListForInternalUpdate.push(userLoginActivity);
      }
       //Remark Comparison
       const userLoginActivity1 = new UserLogInActivity();
       userLoginActivity1.FieldName = " Safety Coordination - Remark " + " " + (i+1);
       userLoginActivity1.OldValue = OldValue[i] != undefined ? OldValue[i].Remarks : ""; 
       userLoginActivity1.NewValue = NewValue[i] != undefined ? NewValue[i].Remarks : "";
      if(userLoginActivity1.OldValue != userLoginActivity1.NewValue)
      {
        this.userActivityListForInternalUpdate.push(userLoginActivity1);
      }
       //Approval Comparison
       const userLoginActivity2 = new UserLogInActivity();
       userLoginActivity2.FieldName = " Safety Coordination - Approval " + " " + (i+1);
       userLoginActivity2.OldValue = OldValue[i] != undefined ? (OldValue[i].IsApproved == true ? "Approve" : "Reject") : ""; 
       userLoginActivity2.NewValue = NewValue[i] != undefined ? (NewValue[i].IsApproved == true ? "Approve" : "Reject") : "";
      if(userLoginActivity2.OldValue != userLoginActivity2.NewValue)
      {
        this.userActivityListForInternalUpdate.push(userLoginActivity2);
      }
     }
    }
    else if(Type == "PTWValidationRecords" && this.IsPTWValidationRecordsEdited)
    {
      let oldValueCount = OldValue == null ? 0 : OldValue.length;
      let newValueCount = NewValue == null ? 0 : NewValue.length;
      let length = oldValueCount > newValueCount ? oldValueCount : newValueCount;
      for(var i=0;i<length;i++)
      {
        //Name of Area Authority Comparison
        const userLoginActivityOAC1 = new UserLogInActivity();
        userLoginActivityOAC1.FieldName = " Validation - Name of Area Authority " + " " + (i+1);
        userLoginActivityOAC1.OldValue = OldValue[i] != undefined ? OldValue[i].user : ""; 
        userLoginActivityOAC1.NewValue = NewValue[i] != undefined ? NewValue[i].username : "";
        if(userLoginActivityOAC1.OldValue != userLoginActivityOAC1.NewValue && !(userLoginActivityOAC1.OldValue != "" && userLoginActivityOAC1.NewValue != ""))
        {
          this.userActivityListForInternalUpdate.push(userLoginActivityOAC1);
        }
       //Validated From Comparison
       const userLoginActivity = new UserLogInActivity();
       userLoginActivity.FieldName = " Validation - Validated From " + " " + (i+1);
       userLoginActivity.OldValue = OldValue[i] != undefined ? this.getFormattedDateTime(moment(moment.utc(OldValue[i].ValidationTimeFrom).local()).toDate()) : ""; 
       userLoginActivity.NewValue = NewValue[i] != undefined ? this.getFormattedDateTime(moment(moment.utc(NewValue[i].ValidationTimeFrom).local()).toDate()) : "";
      if(userLoginActivity.OldValue != userLoginActivity.NewValue && !(userLoginActivity.OldValue != "" && userLoginActivity.NewValue != ""))
      {
        this.userActivityListForInternalUpdate.push(userLoginActivity);
      }
       //Validated To Comparison
       const userLoginActivity2 = new UserLogInActivity();
       userLoginActivity2.FieldName = " Validation - Validated To " + " " + (i+1);
       userLoginActivity2.OldValue = OldValue[i] != undefined ? this.getFormattedDateTime(moment(moment.utc(OldValue[i].ValidationTimeTo).local()).toDate()) : ""; 
       userLoginActivity2.NewValue = NewValue[i] != undefined ? this.getFormattedDateTime(moment(moment.utc(NewValue[i].ValidationTimeTo).local()).toDate()) : "";
      if(userLoginActivity2.OldValue != userLoginActivity2.NewValue && !(userLoginActivity2.OldValue != "" && userLoginActivity2.NewValue != ""))
      {
        this.userActivityListForInternalUpdate.push(userLoginActivity2);
      }
     }
    }
    else if (Type == "PTWAcceptanceRecords" && this.IsPTWAcceptanceRecordsEdited)
    {
      let oldValueCount = OldValue == null ? 0 : OldValue.length;
      let newValueCount = NewValue == null ? 0 : NewValue.length;
      let length = oldValueCount > newValueCount ? oldValueCount : newValueCount;
      for(var i=0;i<length;i++)
      {
       //Name Comparison
       const userLoginActivityOAC1 = new UserLogInActivity();
       userLoginActivityOAC1.FieldName = " Acceptance - Name " + " " + (i+1);
       userLoginActivityOAC1.OldValue = OldValue[i] != undefined ? OldValue[i].user : ""; 
       userLoginActivityOAC1.NewValue = NewValue[i] != undefined ? NewValue[i].username : "";
      if(userLoginActivityOAC1.OldValue != userLoginActivityOAC1.NewValue && !(userLoginActivityOAC1.OldValue != "" && userLoginActivityOAC1.NewValue != ""))
      {
        this.userActivityListForInternalUpdate.push(userLoginActivityOAC1);
      }

       //Designation Comparison
       const userLoginActivityOAC2 = new UserLogInActivity();
       userLoginActivityOAC2.FieldName = " Acceptance - Designation " + " " + (i+1);
       userLoginActivityOAC2.OldValue = OldValue[i] != undefined ? OldValue[i].designation : ""; 
       userLoginActivityOAC2.NewValue = NewValue[i] != undefined ? NewValue[i].designation : "";
      if(userLoginActivityOAC2.OldValue != userLoginActivityOAC2.NewValue && !(userLoginActivityOAC2.OldValue != "" && userLoginActivityOAC2.NewValue != ""))
      {
        this.userActivityListForInternalUpdate.push(userLoginActivityOAC2);
      }

       //Date Comparison
       const userLoginActivity = new UserLogInActivity();
       userLoginActivity.FieldName = " Acceptance - Date " + " " + (i+1);
       userLoginActivity.OldValue = OldValue[i] != undefined ? this.getFormattedDateTime(moment(moment.utc(OldValue[i].date).local()).toDate()) : ""; 
       userLoginActivity.NewValue = NewValue[i] != undefined ? this.getFormattedDateTime(moment(moment.utc(NewValue[i].date).local()).toDate()) : "";
      if(userLoginActivity.OldValue != userLoginActivity.NewValue && !(userLoginActivity.OldValue != "" && userLoginActivity.NewValue != ""))
      {
        this.userActivityListForInternalUpdate.push(userLoginActivity);
      }

       //Remark Comparison
       const userLoginActivity1 = new UserLogInActivity();
       userLoginActivity1.FieldName = " Acceptance - Remark " + " " + (i+1);
       userLoginActivity1.OldValue = OldValue[i] != undefined ? OldValue[i].Remarks : ""; 
       userLoginActivity1.NewValue = NewValue[i] != undefined ? NewValue[i].Remarks : "";
      if(userLoginActivity1.OldValue != userLoginActivity1.NewValue)
      {
        this.userActivityListForInternalUpdate.push(userLoginActivity1);
      }
       //Acceptance Comparison
       const userLoginActivity2 = new UserLogInActivity();
       userLoginActivity2.FieldName = " Acceptance - Acceptance " + " " + (i+1);
       userLoginActivity2.OldValue = OldValue[i] != undefined ? (OldValue[i].IsApproved == true ? "Accept" : "Reject") : ""; 
       userLoginActivity2.NewValue = NewValue[i] != undefined ? (NewValue[i].IsApproved == true ? "Accept" : "Reject") : "";
      if(userLoginActivity2.OldValue != userLoginActivity2.NewValue)
      {
        this.userActivityListForInternalUpdate.push(userLoginActivity2);
      }
     }
    }
    else if (Type == "PTWSuspensionRecords" && this.IsPTWSuspensionRecordsEdited)
    {
      let oldValueCount = OldValue == null ? 0 : OldValue.length;
      let newValueCount = NewValue == null ? 0 : NewValue.length;
      let length = oldValueCount > newValueCount ? oldValueCount : newValueCount;
      for(var i=0;i<length;i++)
      {
      //Name Comparison
      const userLoginActivityOAC1 = new UserLogInActivity();
      userLoginActivityOAC1.FieldName = " Suspension - Name " + " " + (i+1);
      userLoginActivityOAC1.OldValue = OldValue[i] != undefined ? OldValue[i].user : ""; 
      userLoginActivityOAC1.NewValue = NewValue[i] != undefined ? NewValue[i].username : "";
     if(userLoginActivityOAC1.OldValue != userLoginActivityOAC1.NewValue && !(userLoginActivityOAC1.OldValue != "" && userLoginActivityOAC1.NewValue != ""))
     {
       this.userActivityListForInternalUpdate.push(userLoginActivityOAC1);
     }

      //Date Comparison
      const userLoginActivity = new UserLogInActivity();
      userLoginActivity.FieldName = " Suspension - Date " + " " + (i+1);
      userLoginActivity.OldValue = OldValue[i] != undefined ? this.getFormattedDateTime(moment(moment.utc(OldValue[i].date).local()).toDate()) : ""; 
      userLoginActivity.NewValue = NewValue[i] != undefined ? this.getFormattedDateTime(moment(moment.utc(NewValue[i].date).local()).toDate()) : "";
     if(userLoginActivity.OldValue != userLoginActivity.NewValue && !(userLoginActivity.OldValue != "" && userLoginActivity.NewValue != ""))
     {
       this.userActivityListForInternalUpdate.push(userLoginActivity);
     }

      //Remark Comparison
      const userLoginActivity1 = new UserLogInActivity();
      userLoginActivity1.FieldName = " Suspension - Remark " + " " + (i+1);
      userLoginActivity1.OldValue = OldValue[i] != undefined ? OldValue[i].Remarks : ""; 
      userLoginActivity1.NewValue = NewValue[i] != undefined ? NewValue[i].Remarks : "";
     if(userLoginActivity1.OldValue != userLoginActivity1.NewValue)
     {
       this.userActivityListForInternalUpdate.push(userLoginActivity1);
     }
     }
    }
    if (this.userActivityListForInternalUpdate.length > 0) {
      this.commonService.saveUserActivityDetails(
       this.permitId,
        new Date(),
        "PTW",
        this.loggedInUserJSON.UserId,
        this.userActivityListForInternalUpdate
      );
    }
  }

 AddActivityForCertificates(Field,OldValue,NewValue)
 {
  const userLoginActivity = new UserLogInActivity();
  userLoginActivity.FieldName = Field ;
  userLoginActivity.OldValue = OldValue;
  userLoginActivity.NewValue = NewValue;
  this.userActivityList.push(userLoginActivity);
 }

  changeStatus(priorityToFormat) {
    let strPriority = null;
    switch (priorityToFormat) {
      case false:
        strPriority = "false";
        break;
      case true:
        strPriority = "true";
        break;
        case "false":
        strPriority = "false";
        break;
      case "true":
        strPriority = "true";
        break;
        
    }
    return strPriority;
  }
  
  getUsersOnSearch(event) {
    this.searchTexts.UserTypeId = 0;
    this.searchTexts.FilterTexts = event.query;
    this.searchTexts.CompanyId = 0;
    this.searchTexts.UnitId = -1;
    const apiRequest = {
      Model: this.searchTexts
    };
    this.commonService.getSearchResultsForUsers(apiRequest, this.callbackMethodForGetSearchResultsForUsersData.bind(this));
  }

  callbackMethodForGetSearchResultsForUsersData(response) {
    if (response === undefined) {
      this.serviceError();
    }

    if (response.Success) {
      const filtered: any[] = [];
      for (let i = 0; i < response.Result.length; i++) {
        const user = response.Result[i];
        if (
          user.FullName.toLowerCase().indexOf(
            this.searchTexts.FilterTexts.toLowerCase()
          ) !== -1
        ) {
          filtered.push(user);
        }
      }
      this.userResults = filtered;
    }

    if (response.Errors !== null) {
      this.hseErrorHandler.handleError(response.Errors);
    }
  }

  selectUser(event) {
    if (event.UserId) {
      this.PTWForm.patchValue({ Name: event });
      this.PTWForm.patchValue({ TelNumber: event.ContactNumber });
      this.PTWForm.patchValue({ UserId: event.UserId });
    }
  }

  getContractorsOnSearch(event) {
    this.searchTexts.UserTypeId = 2;
    this.searchTexts.FilterTexts = event.query;
    this.searchTexts.CompanyId = 0;
    this.searchTexts.UnitId = -1;
    const apiRequest = {
      Model: this.searchTexts
    };
    this.commonService.getSearchResultsForUsers(apiRequest, this.callbackMethodForGetSearchResultsForUsersData.bind(this));
  }

  selectContractor(event) {
    if (event.UserId)
      this.PTWForm.patchValue({ ContractorName: event });
  }

  selectActivity(event) {
    if (event.value)
      this.PTWForm.patchValue({ SelectedActivity: event });
  }

  selectSubActivity(event) {
    if (event.value)
      this.PTWForm.patchValue({ SelectedSubActivity: event });
  }

  GasSelectedCheck(selectedValue, type) {
    switch (type) {
      case "GasTestedForHC":
        this.PTWForm.patchValue({ GasTestedForHC: selectedValue });
        break;
      case "GasTestedForH2S":
        this.PTWForm.patchValue({ GasTestedForH2S: selectedValue });
        break;
      case "GasTestedForO2":
        this.PTWForm.patchValue({ GasTestedForO2: selectedValue });
        break;
      case "GasTestedForOther":
        this.PTWForm.patchValue({ GasTestedForOther: selectedValue });
        if (selectedValue) {
          this.PTWForm.controls["GasTestSpecify"].setValidators([Validators.required]);
        } else {
          this.PTWForm.controls["GasTestSpecify"].clearValidators();
        }
        this.PTWForm.get("GasTestSpecify").updateValueAndValidity();
        break;
      default:
        break;
    }
    if (this.PTWForm.value.GasTestedForHC ||
      this.PTWForm.value.GasTestedForH2S ||
      this.PTWForm.value.GasTestedForO2 ||
      this.PTWForm.value.GasTestedForOther) {
      this.PTWForm.controls["GasTestInterval"].setValidators([Validators.required]);
      this.PTWForm.controls["GasTestInterval"].updateValueAndValidity();
    }
    else {
      this.PTWForm.controls["GasTestInterval"].clearValidators();
      this.PTWForm.controls["GasTestInterval"].updateValueAndValidity();
    }
  }

  vehicleSelectedCheck() {
    if (this.PTWForm.value.IsVehicleRequired == "true") {
      this.PTWForm.controls["VehicleType"].setValidators([Validators.required]);
      this.PTWForm.controls["Location"].setValidators([Validators.required]);
    }
    else {
      this.PTWForm.controls["VehicleType"].clearValidators();
      this.PTWForm.controls["Location"].clearValidators();
    }
    this.PTWForm.controls["VehicleType"].updateValueAndValidity();
    this.PTWForm.controls["Location"].updateValueAndValidity();
  }

  callbackMethodForGetActivities(response) {
    if (response.Success) {
      this.activitiesCheckList = [];
      this.checkListDetails = response.Result;
      this.checkListDetails.forEach((check) => {
        this.activitiesCheckList.push({
          label: check.CheckListName,
          value: check.CheckListId
        });
      });
    }
    this.baseService.showRootLoader = false;
  }

  GetActivities() {
    this.ActivityDataSub = this.PTWService.getActivities().subscribe(
      response => {
        if (response.Result) {
          this.activityList = [];
          for (let item of response.Result) {
            this.activityList.push({ value: item.ActivityId, label: item.ActivityNumber + ". " + item.ActivityName });
          }
        }
      }
    );
  }

  getSubActivities(event) {
    const model = event.value
    this.getSubActivityServiceCall(model);
  }

  getSubActivityServiceCall(activityId) {
    this.SubActivityDataSub = this.PTWService.getSubActivities(activityId).subscribe(
      response => {
        this.subActivityList = [];
        let SubActivityMatrixFound = [];
        if (response.Result) {
          this.allSubActivities = response.Result;
          for (let item of response.Result) {
            this.subActivityList.push({ value: item.SubActivityId, label: item.ActivityNumber + ". " + item.ActivityName });
            this.activityMatrixList.forEach(s => {
              if (s.SubActivity == item.SubActivityId) {
                SubActivityMatrixFound.push(s);
              }
            });
          }
          let groupedData = this.groupBy(SubActivityMatrixFound, segments => segments.PermitType);

          if (groupedData.size == 1) {
            let permitType = groupedData.keys().next().value;
            if (permitType == PermitType.RedEdge) {
              this.PTWForm.patchValue({ PermitType: " Class A (Red Edge Permit)" });
              this.permitClassName = "red-edge-class";
            }
            else if (permitType == PermitType.BlueEdge) {
              this.PTWForm.patchValue({ PermitType: " Class B (Blue Edge Permit)" });
              this.permitClassName = "blue-edge-class";
            }
            else if (permitType == PermitType.NoPermit) {
              this.IsDirectNoPermitJob = true;
              this.PTWForm.patchValue({ PermitType: " No Permit Job" });
              this.IdentifyIsPermit();
            }
          }
          else if (!this.isUpdate) {
            this.PTWForm.patchValue({ PermitType: "" });
            this.permitClassName = "";
          }
        }
      });
  }

  GetActivityMatrix() {
    this.PTWService.getActivityMatrix().subscribe(
      response => {
        if (response.Result) {
          this.activityMatrixList = [];
          for (let item of response.Result) {
            this.activityMatrixList.push({
              Id: item.Id,
              SubActivity: item.SubActivity,
              IsProcessFacility: Boolean(item.IsProcessFacility),
              IsHydrocarbonArea: Boolean(item.IsHydrocarbonArea),
              IsGasTestBeforeAfterDay: Boolean(item.IsGasTestBeforeAfterDay),
              IsGasTestEveryTwoHour: Boolean(item.IsGasTestEveryTwoHour),
              IsContinueGasMonitoring: Boolean(item.IsContinueGasMonitoring),
              HazardousZoneOne: Boolean(item.HazardousZoneOne),
              HazardousZoneTwo: Boolean(item.HazardousZoneTwo),
              NonHazardousZone: Boolean(item.NonHazardousZone),
              IsSafetyEquipment: Boolean(item.IsSafetyEquipment),
              PermitType: item.PermitType,
              AdditionalComments: item.AdditionalComments,
              RequiredCertificates: item.RequiredCertificates
            });
          }
        }
      }
    );
  }

  decidePermitType(): void {
    let typeData = this.activityMatrixList.find(p => p.SubActivity == this.PTWForm.value.SelectedSubActivity);

    if (typeData) {
      this.permit = typeData.PermitType;
      this.activityMatrixId = parseInt(typeData.SubActivity);
      if (!this.isUpdate) {
        this.getCertificateRequired();
      }
      let SubActivityNumber = this.allSubActivities.find(p => p.SubActivityId == this.activityMatrixList.find(p => this.PTWForm.value.SelectedSubActivity == p.SubActivity).SubActivity).ActivityNumber;

      let hazardusZones = [];
      typeData.HazardousZoneOne ? hazardusZones.push(1) : "";
      typeData.HazardousZoneTwo ? hazardusZones.push(2) : "";
      typeData.NonHazardousZone ? hazardusZones.push(3) : "";

      if (hazardusZones.join() == "") {
        this.PTWForm.patchValue({ IsHazardousArea: "false" });
      }
      else {
        this.PTWForm.patchValue({ IsHazardousArea: "true" });
        this.PTWForm.patchValue({ HazardousZones: hazardusZones.map(String) });
      }

      this.PTWForm.patchValue({ IsProcessFacility: typeData.IsProcessFacility ? "true" : "false" });
      this.PTWForm.patchValue({ IsHydrocarbonArea: typeData.IsHydrocarbonArea ? "true" : "false" });
      this.PTWForm.patchValue({ IsGasTestBeforeAfterDay: typeData.IsGasTestBeforeAfterDay ? "true" : "false" });
      this.PTWForm.patchValue({ IsGasTestEveryTwoHour: typeData.IsGasTestEveryTwoHour ? "true" : "false" });
      this.PTWForm.patchValue({ IsContinueGasMonitoring: typeData.IsContinueGasMonitoring ? "true" : "false" });
      this.PTWForm.patchValue({ IsSafetyEquipment: typeData.IsSafetyEquipment ? "true" : "false" });

      this.PTWForm.get("IsProcessFacility").disable();
      this.PTWForm.get("IsHydrocarbonArea").disable();
      this.PTWForm.get("IsHazardousArea").disable();
      this.PTWForm.get("HazardousZones").disable();
      this.PTWForm.get("IsGasTestBeforeAfterDay").disable();
      this.PTWForm.get("IsGasTestEveryTwoHour").disable();
      this.PTWForm.get("IsContinueGasMonitoring").disable();
      this.PTWForm.get("IsSafetyEquipment").disable();

      if (this.permit == PermitType.RedEdge.toString()) {
        this.isPermitTypeDecided = true;
        this.isPermitJob = true;
        this.PTWForm.patchValue({ PermitType: " Class A (Red Edge Permit)" });
        this.permitClassName = "red-edge-class";
        this.PTWForm.patchValue({ PTWNumber: this.PTWForm.get("SelectedUnit").value.UnitName + "/" + "A" + "/" + SubActivityNumber + "/" + (new Date).getFullYear() + "/" + "XXXX" });
      }
      else if (this.permit == PermitType.BlueEdge.toString()) {
        this.isPermitTypeDecided = true;
        this.isPermitJob = true;
        this.PTWForm.patchValue({ PermitType: " Class B (Blue Edge Permit)" });
        this.permitClassName = "blue-edge-class";
        this.PTWForm.patchValue({ PTWNumber: this.PTWForm.get("SelectedUnit").value.UnitName + "/" + "B" + "/" + SubActivityNumber + "/" + (new Date).getFullYear() + "/" + "XXXX" });
      }
      else if (this.permit == "3") {
        this.isPermitTypeDecided = true;
        this.IsDirectNoPermitJob = true;
        this.PTWForm.patchValue({ PermitType: " No Permit Job" });
        this.PTWForm.patchValue({ PTWNumber: this.PTWForm.get("SelectedUnit").value.UnitName + "/" + "N" + "/" + SubActivityNumber + "/" + (new Date).getFullYear() + "/" + "XXXX" });
        this.IdentifyIsPermit();
        this.permitClassName = "";
      }
      if (typeData.AdditionalComments) {
        this.PTWForm.patchValue({ AdditionalComments: typeData.AdditionalComments });
      }
      else {
        this.PTWForm.patchValue({ AdditionalComments: "" });
      }

      this.Certificates.forEach(c => {
        if (typeData.RequiredCertificates.includes(c.CertificateType)) {
          c.IsRequired = true;
        } else {
          c.IsRequired = false;
        }
      });
      this.PTWForm.updateValueAndValidity();
    }
  }
  GetCertificates() {
    this.PTWService.getCertificates(false).subscribe(
      response => {
        if (response.Success) {
          for (let item of response.Result) {
            if (item.IsActive) {
              this.Certificates.push({ CertificateType: item.CertificateId, CertificateName: item.CertificateName, Files: [], TemplateFiles: item.TemplateFiles, IsRequired: false, IsDisabled: false, IsApproved: item.IsApproved, Remarks: item.Remarks, RemarkRequired: false, UploadRequired: false, CurrentVersion: item.CurrentVersion });
            }
          }
        }
      }
    );
  }

  GetHazardousAreas() {
    this.hazardousZones = this.hazardousZonesDropdown;
  }

  ShowDialog() {
    this.dialogHeight = (window.innerHeight - 50).toString() + "px";
    this.dialogWidth = window.innerWidth.toString() + "px";
  }

  parentFunction(data) {
    this.PTWDialogModel.IsWithinFacilities = data.IsWithinFacilities;
    this.PTWDialogModel.IsHydrocarbonArea = data.IsHydrocarbonArea;
    this.PTWDialogModel.IsElectricalInstallations = data.IsElectricalInstallations;
    this.PTWDialogModel.IsConfinedSpace = data.IsConfinedSpace;
    this.PTWDialogModel.IsSupplementaryCertificate = data.IsSupplementaryCertificate;
    this.PTWDialogModel.IsEmergencyPlanning = data.IsEmergencyPlanning;
    this.PTWDialogModel.IsWorkForce = data.IsWorkForce;
    this.PTWDialogModel.IsCompetentStaff = data.IsCompetentStaff;
    this.PTWDialogModel.IsWrittenProcedure = data.IsWrittenProcedure;
    this.PTWDialogModel.IsPlanWritten = data.IsPlanWritten;
    this.PTWDialogModel.IsSupervisorAppointed = data.IsSupervisorAppointed;

    this.display = false;
    this.IdentifyIsPermit();
  }

  IdentifyIsPermit() {
    this.baseService.showRootLoader = true;
    if ((this.PTWDialogModel.IsWithinFacilities === "false" && this.PTWDialogModel.IsHydrocarbonArea === "false" &&
      this.PTWDialogModel.IsElectricalInstallations === "false" && this.PTWDialogModel.IsConfinedSpace === "false" &&
      this.PTWDialogModel.IsSupplementaryCertificate === "false" && this.PTWDialogModel.IsEmergencyPlanning === "false" &&
      this.PTWDialogModel.IsWorkForce === "true" && this.PTWDialogModel.IsCompetentStaff === "true" &&
      this.PTWDialogModel.IsWrittenProcedure === "true" && this.PTWDialogModel.IsPlanWritten === "true" &&
      this.PTWDialogModel.IsSupervisorAppointed === "true") || this.IsDirectNoPermitJob) {

      this.isPermitJob = false;

      for (const key in this.PTWForm.controls) {
        this.PTWForm.get(key).clearValidators();
        this.PTWForm.get(key).updateValueAndValidity();
      }
      this.PTWForm.get("SelectedActivity").setValidators(Validators.required);
      this.PTWForm.get("SelectedActivity").updateValueAndValidity();
      this.PTWForm.get("SelectedSubActivity").setValidators(Validators.required);
      this.PTWForm.get("SelectedSubActivity").updateValueAndValidity();
      this.PTWForm.get("IsProcessFacility").setValidators(Validators.required);
      this.PTWForm.get("IsProcessFacility").updateValueAndValidity();
      this.PTWForm.get("IsHydrocarbonArea").setValidators(Validators.required);
      this.PTWForm.get("IsHydrocarbonArea").updateValueAndValidity();
      this.PTWForm.get("IsGasTestBeforeAfterDay").setValidators(Validators.required);
      this.PTWForm.get("IsGasTestBeforeAfterDay").updateValueAndValidity();
      this.PTWForm.get("IsGasTestEveryTwoHour").setValidators(Validators.required);
      this.PTWForm.get("IsGasTestEveryTwoHour").updateValueAndValidity();
      this.PTWForm.get("IsContinueGasMonitoring").setValidators(Validators.required);
      this.PTWForm.get("IsContinueGasMonitoring").updateValueAndValidity();
      this.PTWForm.get("IsSafetyEquipment").setValidators(Validators.required);
      this.PTWForm.get("IsSafetyEquipment").updateValueAndValidity();
      this.PTWForm.get("unitLocation").setValidators(Validators.required);
      this.PTWForm.get("unitLocation").updateValueAndValidity();
      this.PTWForm.get("ExactLocation").setValidators(Validators.required);
      this.PTWForm.get("ExactLocation").updateValueAndValidity();
      this.PTWForm.get("Worksite").setValidators(Validators.required);
      this.PTWForm.get("Worksite").updateValueAndValidity();
      this.PTWForm.get("WorkDescription").setValidators(Validators.required);
      this.PTWForm.get("WorkDescription").updateValueAndValidity();
      this.PTWForm.get("ContractorName").setValidators(Validators.required);
      this.PTWForm.get("ContractorName").updateValueAndValidity();
      this.PTWForm.get("DateFrom").setValidators(Validators.required);
      this.PTWForm.get("DateFrom").updateValueAndValidity();
      this.PTWForm.get("DateTo").setValidators(Validators.required);
      this.PTWForm.get("DateTo").updateValueAndValidity();

      this.PTWForm.patchValue({ PermitType: 'No Permit' });

    }
    else {
      this.isPermitJob = true;
    }
    this.baseService.showRootLoader = false;
  }

  CheckHazardousArea() {
    if (this.PTWForm.get("IsHazardousArea").value == "true") {
      this.PTWForm.controls["HazardousZones"].setValidators([Validators.required]);
      this.PTWForm.get("HazardousZones").updateValueAndValidity();
    } else {
      this.PTWForm.controls["HazardousZones"].clearValidators();
      this.PTWForm.get("HazardousZones").updateValueAndValidity();
    }
  }

  setExactLocation(data: string): void {
    this.PTWForm.patchValue({ ExactLocation: data });
  }

  get gasTests() {
    return this.PTWForm.get('GasTestecords') as FormArray;
  }

  addGasTestRecords() {
    let gasTestArr = this.PTWForm.get('GasTestRecords') as FormArray;

    let newGasTests = this.formBuilder.group({
      GasTestRecordId: [''],
      Date: [''],
      Result: [''],
      UserId: ['']
    });

    gasTestArr.controls.push(newGasTests);
  }

  RemoveGasTestRecords(i) {
    let gasTestArr = this.PTWForm.get('GasTestRecords') as FormArray;
    gasTestArr.removeAt(i);
  }

  onInputFilesUpdated(files, type, index) {
    switch (type) {
      case "Certificate":
        this.Certificates[index].Files = files;
        break;
      case "SafetyEnvironmentPlan":
        this.SafetyEnvironmentPlanFiles = files;
        break;
      case "VehicleEntryChecklist":
        this.VehicleEntryChecklistFiles = files;
        break;
      default:
        break;
    }
  }

  ResetForm() {
    this.dialogType = "ConfirmReset";
    this.alertType = "Confirm";
    this.successDetails = null;
    this.errorDetails = null;
    this.confirmMessage = "You have clicked reset button. All information entered by you on this page will be lost. Do you want to reset the form?";
  }

  ngOnDestroy() {
    this.ActivityDataSub ? this.ActivityDataSub.unsubscribe() : null;
    this.SubActivityDataSub ? this.SubActivityDataSub.unsubscribe() : null;
  }
   
   
  ngOnInit(): void {
    this.PTWForm = this.formBuilder.group({
      Contract: new FormControl('', Validators.required),
      PermitType: new FormControl(),
      ExactLocation: new FormControl('', Validators.required),
      Worksite: new FormControl('', Validators.required),
      WorkDescription: new FormControl('', Validators.required),
      ExpectedMaxPPM: new FormControl('', [Validators.required, Validators.pattern("^[0-9]+.?[0-9]*")]),
      AssociatedPTWno: new FormControl(),
      EWPno: new FormControl(),
      VehicleType: new FormControl(''),
      Location: new FormControl(''),
      ContractorName: new FormControl('', Validators.required),
      Contractor: new FormControl(),
      ZoneOfWork: new FormControl(),
      SelectedActivity: new FormControl('', Validators.required),
      SelectedSubActivity: new FormControl('', Validators.required),
      HazardousZones: new FormControl(),
      SelectedUnit: new FormControl('', Validators.required),
      IsNORMContaminatedArea: new FormControl("false", Validators.required),
      IsMercuryPotential: new FormControl("false", Validators.required),
      H2SFacilityClassification: new FormControl("Normal", Validators.required),
      GasTestedForHC: new FormControl(),
      GasTestedForH2S: new FormControl(),
      GasTestedForO2: new FormControl(),
      GasTestedForOther: new FormControl(false),
      GasTestSpecify: new FormControl(),
      GasTestInterval: new FormControl(),
      IsGasMonitoringRequired: new FormControl("false", Validators.required),
      IsVehicleRequired: new FormControl("false", Validators.required),
      IsVehicleApproved: new FormControl("false", Validators.required),
      IsAgreeFrozenPlan: new FormControl(false, Validators.required),
      DateFrom: new FormControl('', Validators.required),
      DateTo: new FormControl('', Validators.required),
      IsGasTestBeforeAfterDay: new FormControl("false", Validators.required),
      IsGasTestEveryTwoHour: new FormControl("false", Validators.required),
      IsContinueGasMonitoring: new FormControl("false", Validators.required),
      IsSafetyEquipment: new FormControl("false", Validators.required),
      IsConfinedSpace: new FormControl("false", Validators.required),
      IsElectricalInstallations: new FormControl("false", Validators.required),
      IsEmergencyPlanning: new FormControl("false", Validators.required),
      IsWrittenProcedure: new FormControl("false", Validators.required),
      IsCompetentStaff: new FormControl("false", Validators.required),
      IsWorkForce: new FormControl("false", Validators.required),
      IsSupplementaryCertificate: new FormControl("false", Validators.required),
      IsProcessFacility: new FormControl("false", Validators.required),
      IsHydrocarbonArea: new FormControl("false", Validators.required),
      PTWNumber: new FormControl(),
      IsHazardousArea: new FormControl("false", Validators.required),
      HazardousZone: new FormControl(),
      IsWorkExaminationFirstDay: new FormControl("false", Validators.required),
      IsValidatorEveryday: new FormControl("false", Validators.required),
      AdditionalComments: new FormControl(),
      isDailyValidationAllowed: new FormControl("false"),
      isHoursValidationAllowed: new FormControl("false"),
      isEquipmentSafeCondition: new FormControl("false"),
      isWorksiteSafeAndClear: new FormControl("false"),
      isReinstatementsComplete: new FormControl("false"),
      dateFromRS: new FormControl(),
      dateToRS: new FormControl(),
      extensionValidTo: new FormControl(),
      remarksRS: new FormControl(),
      remarksPS: new FormControl(),
      remarksExtension: new FormControl(),
      remarksCancellation: new FormControl(),
      unitLocation: new FormControl('', Validators.required),
      btnRSApprove: new FormControl("Approve"),
      btnRSReject: new FormControl("Reject"),
      btnPSApprove: new FormControl("Approve"),
      btnPSReject: new FormControl("Reject"),
      btnExtensionApprove: new FormControl("Approve"),
      btnExtensionReject: new FormControl("Reject"),
      btnUpdateGasTestRecord: new FormControl("Update Records"),
      btnUpdateOACRecord: new FormControl("Update Records"),
      btnUpdateSafetyCoordinatorRecord: new FormControl("Update Records"),
      btnUpdateValidationRecord: new FormControl("Update Records"),
      btnUpdateAcceptanceRecord: new FormControl("Update Records"),
      btnUpdateSuspensionRecord: new FormControl("Update Records"),
      btnApplyCancellationApprove: new FormControl("Work Complete"),
      btnApplyCancellationReject: new FormControl("Work Not Complete"),
      btnCancellationApprove: new FormControl("Approve"),
      btnCancellationReject: new FormControl("Reject"),
      oncomingHolders: new FormControl('', Validators.required),
      GasTestRecords: new FormArray([
        this.formBuilder.group({
          GasTestRecordId: new FormControl(0),
          Date: new FormControl(new Date()),
          Result: new FormControl(''),
          UserId: new FormControl('')
        })
      ])
    });

    this.disablePermit = false;

    this.GetCertificates();
    this.independentPermissions = JSON.parse(
      this.baseService.getItemFromSession("UserIndependentPermissions")
    );
    const loggedInUser = this.baseService.getItemFromSession("loggedInUser");
    this.loggedInUserJSON = JSON.parse(loggedInUser);
    // this.nameRS = this.loggedInUserJSON.FullName;
    // this.designationRS = this.loggedInUserJSON.Designation;
    // this.namePS = this.loggedInUserJSON.FullName;
    // this.designationPS = this.loggedInUserJSON.Designation;
    // this.designationExtension = this.loggedInUserJSON.Designation;
    // this.nameExtension = this.loggedInUserJSON.FullName;
    this.applicantName = this.loggedInUserJSON.FullName;
    this.applicantDesignation = this.loggedInUserJSON.Designation;
    this.applicantTelNo = this.loggedInUserJSON.ContactNumber;

    this.sub = this.route.params.subscribe((params) => {
      this.permitId = coerceNumberProperty(params["permitId"])
      this.unitId = coerceNumberProperty(params["unitId"]);
    });
    this.getIsActiveUnit(this.unitId);
    if (this.permitId !== 0 && this.permitId) {
      this.display = false;
      this.IsNewRecord = false;
    }
     
     

    this.routesFlag = PermitToWorkConstantsService.PTWNavigation.InnerRoutes;
    this.reportRoutes = PermitToWorkConstantsService.PTWNavigation.ReportRoutes;
    this.getUnits();
    this.DisableRecordsEditedPropertyForTableData();
  }
  checkIsUpdateProcess() {
    if (this.permitId !== 0 && this.permitId) {
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          "PermitId": this.permitId
        }
      };
      this.PTWService.getPTWRequestByPermitId(apiRequest, this.callbackMethodForGetRequestByPermitId.bind(this))
    }
  }
  callbackMethodForGetRequestByPermitId(response) {
    if (response.Success) {
      // if (this.loggedInUserJSON.UserTypes.UserType ===
      //    ObservationConstantsService.RequestFor.Contractor && response.Result.PTWRequestDetails.CreatedBy != this.loggedInUserJSON.UserId
      // ) {
      //   this.notificationsService.toastNotify(
      //     "error",
      //     "Warning Message",
      //     "This Permit To Work not raised by you, you don't have permission to view this record...!"
      //   );   
      //    this.router.navigate(["ptw/permit-overview"]);
      //    return ; 
      // }
      
      if (response.Result.PTWRequestDetails.PermitType == PermitType.NoPermit) {
        this.IsDirectNoPermitJob = true;
      } else {
        this.IsDirectNoPermitJob = false;
      }
      this.IdentifyIsPermit();
      this.ptwRequest = response.Result;
      this.isUpdate = true;
      this.permitStatus = response.Result.PTWRequestDetails.Status;
      this.unitTree.forEach((element) => {
        this.compareTreeNode(element, response.Result.PTWRequestDetails.UnitId);
      });

      this.PTWForm.patchValue({ SelectedUnit: this.selectedUnit });
      
      this.PTWForm.patchValue({ Contract: response.Result.PTWRequestDetails.ContractId });
      this.isEmployeeUnit=true;
      if(this.selectedUnit.UnitTypeId == 2)
      {
        this.isEmployeeUnit=false;
        this.getContractDetails(this.selectedUnit.UnitId);
       
      }
      this.selectedContract = response.Result.PTWRequestDetails.ContractId;
      this.PTWForm.patchValue({ contr: this.selectedUnit });

       

      this.SelectedUserId = response.Result.PTWRequestDetails.ApplicantName;
      this.SelectedContractor = response.Result.PTWRequestDetails.ApplicantContractor;
      if (this.allUsers && this.allUsers.length) {
        this.user = this.allUsers.find(u => u.UserId == this.SelectedUserId);
        if (this.user) {
          this.applicantName = this.user.FullName;
          this.applicantDesignation = this.user.Designation;
          this.applicantTelNo = this.user.ContactNumber;
          this.PTWForm.patchValue({ UserId: this.user.UserId });
          let contractorUser = this.allUsers.find(u => u.UserId == this.SelectedContractor);
          this.PTWForm.patchValue({ ContractorName: contractorUser });
        }
      }
      this.getLocation();
      this.PTWForm.patchValue({ unitLocation: response.Result.PTWRequestDetails.LocationId });
      this.getSubActivityServiceCall(response.Result.PTWRequestDetails.MainActivity);
      this.PTWForm.patchValue({ IsProcessFacility: response.Result.PTWRequestDetails.ProcessFacility ? "true" : "false" });
      this.PTWForm.patchValue({ IsHydrocarbonArea: response.Result.PTWRequestDetails.HydrocarbonArea ? "true" : "false" });
      this.PTWForm.patchValue({ IsHazardousArea: response.Result.PTWRequestDetails.HazardousArea == "0" ? "false" : "true" });
      this.PTWForm.patchValue({ IsGasTestBeforeAfterDay: response.Result.PTWRequestDetails.GasTestrequiredBeforeWorkStart ? "true" : "false" });
      this.PTWForm.patchValue({ IsGasTestEveryTwoHour: response.Result.PTWRequestDetails.GasTestrequiredEveryTwoHr ? "true" : "false" });
      this.PTWForm.patchValue({ IsContinueGasMonitoring: response.Result.PTWRequestDetails.GasMonitoringRequired ? "true" : "false" });
      this.PTWForm.patchValue({ IsSafetyEquipment: response.Result.PTWRequestDetails.SafetyEquipmentRequired ? "true" : "false" });
      if (this.isPermitJob) {
        this.PTWForm.patchValue({ IsNORMContaminatedArea: response.Result.PTWRequestDetails.NORMContaminatedArea ? "true" : "false" });
        this.PTWForm.patchValue({ IsMercuryPotential: response.Result.PTWRequestDetails.MercuryPotential ? "true" : "false" });
        this.PTWForm.patchValue({ IsWorkExaminationFirstDay: response.Result.PTWRequestDetails.WorkExaminationFirstDay ? "true" : "false" });
        this.PTWForm.patchValue({ IsValidatorEveryday: response.Result.PTWRequestDetails.ValidatorEveryday ? "true" : "false" });
        this.PTWForm.patchValue({ IsVehicleRequired: response.Result.PTWRequestDetails.VehicleEntryRequired ? "true" : "false" });
        this.PTWForm.patchValue({ IsVehicleApproved: response.Result.PTWRequestDetails.VehicleAccessPlanApproved ? "true" : "false" });
        this.PTWForm.patchValue({ IsAgreeFrozenPlan: response.Result.PTWRequestDetails.AgreesFrozenPlan });
        this.PTWForm.patchValue({ ExpectedMaxPPM: response.Result.PTWRequestDetails.ExpectedMaxPPM });
        this.PTWForm.patchValue({ AssociatedPTWno: response.Result.PTWRequestDetails.AssociatedPTWNo });
        this.PTWForm.patchValue({ EWPno: response.Result.PTWRequestDetails.WorkOrderNumber });
        this.PTWForm.patchValue({ VehicleType: response.Result.PTWRequestDetails.PermittedVehicleType });
        this.PTWForm.patchValue({ Location: response.Result.PTWRequestDetails.PermittedVehicleLocation });
        this.PTWForm.patchValue({ H2SFacilityClassification: response.Result.PTWRequestDetails.H2SFacilityClassification });
      }
      this.PTWForm.patchValue({ WorkDescription: response.Result.PTWRequestDetails.WorkDescription });
      if (response.Result.PTWRequestDetails.Other == "") {
        this.PTWForm.patchValue({ GasTestedForOther: false });
      }
      else {
        this.PTWForm.patchValue({ GasTestedForOther: true });
      }

      this.PTWForm.patchValue({ PTWNumber: response.Result.PTWRequestDetails.PermitNumber });
      this.PTWForm.patchValue({ SelectedActivity: response.Result.PTWRequestDetails.MainActivity });
      this.PTWForm.patchValue({
        PermitType: response.Result.PTWRequestDetails.PermitType == PermitType.RedEdge ?
          "Class A (Red Edge Permit)" : response.Result.PTWRequestDetails.PermitType == PermitType.BlueEdge ?
            "Class B (Blue Edge Permit)" : response.Result.PTWRequestDetails.PermitType == PermitType.NoPermit ?
              "No Permit Job" : ""
      });
      this.permitClassName = response.Result.PTWRequestDetails.PermitType == PermitType.RedEdge ?
        "red-edge-class" : response.Result.PTWRequestDetails.PermitType == PermitType.BlueEdge ?
          "blue-edge-class" : "";

      this.PTWForm.patchValue({ ExactLocation: response.Result.PTWRequestDetails.ExactLocation });
      this.PTWForm.patchValue({ Worksite: response.Result.PTWRequestDetails.WorkSite });
      this.PTWForm.patchValue({ WorkDescription: response.Result.PTWRequestDetails.WorkDescription });
      this.permitDate = moment(moment.utc(response.Result.PTWRequestDetails.CreatedDate).local()).toDate();
      this.PTWForm.patchValue({ DateFrom: moment(moment.utc(response.Result.PTWRequestDetails.PermitDurationFrom).local()).toDate() });
      this.PTWForm.patchValue({ DateTo: moment(moment.utc(response.Result.PTWRequestDetails.PermitDurationTo).local()).toDate() });
      this.PTWForm.patchValue({ SelectedSubActivity: response.Result.PTWRequestDetails.Activity });
      this.activityMatrixId = response.Result.PTWRequestDetails.Activity;
      this.getCertificateRequired();
      this.PTWForm.patchValue({
        GasTestedForHC: response.Result.PTWRequestDetails.GasHydrocarbon,
        GasTestedForH2S: response.Result.PTWRequestDetails.GasH2S,
        GasTestedForO2: response.Result.PTWRequestDetails.GasOxygen
      });

      this.PTWForm.patchValue({ GasTestSpecify: response.Result.PTWRequestDetails.Other });
      this.PTWForm.patchValue({
        GasTestInterval: response.Result.PTWRequestDetails.GasTestInterval == 0 ?
          "" : response.Result.PTWRequestDetails.GasTestInterval
      });
      this.PTWForm.patchValue({ AdditionalComments: response.Result.PTWRequestDetails.AdditionalComment });
      this.PTWForm.patchValue({ HazardousZones: response.Result.PTWRequestDetails.HazardousArea.split(',') });

      this.fromDateOfPermit = moment(moment.utc(response.Result.PTWRequestDetails.PermitDurationFrom).local()).toDate();
      this.PTWForm.patchValue({ dateFromRS: moment(moment.utc(this.fromDateOfPermit).local()).toDate() });
      this.onRSFromDateChange(response.Result.PTWRequestDetails.PermitType);
      this.onDurationFromDateChange(response.Result.PTWRequestDetails.PermitType);

      this.PTWForm.get("IsProcessFacility").disable();
      this.PTWForm.get("SelectedSubActivity").disable();
      this.PTWForm.get("SelectedActivity").disable();
      this.PTWForm.get("IsProcessFacility").disable();
      this.PTWForm.get("IsHydrocarbonArea").disable();
      this.PTWForm.get("IsHazardousArea").disable();
      this.PTWForm.get("HazardousZones").disable();
      this.PTWForm.get("IsGasTestBeforeAfterDay").disable();
      this.PTWForm.get("IsGasTestEveryTwoHour").disable();
      this.PTWForm.get("IsContinueGasMonitoring").disable();
      this.PTWForm.get("IsSafetyEquipment").disable();
      // Approval bindings
      if (response.Result.ApprovalDetails) {
        if (!this.isPermitJob) {
          let approvalRS = response.Result.ApprovalDetails.find(element => element.ApprovalType == ApprovalType.ResponsibleSupervisor);
          if (approvalRS) {
            if (approvalRS.IsApproved) {
              this.PTWForm.get("btnRSApprove").disable();
              this.nameRS = this.allUsers.find(u => u.UserId == approvalRS.ApprovedBy).FullName;
              this.designationRS = this.allUsers.find(u => u.UserId == approvalRS.ApprovedBy).Designation;
              this.PTWForm.patchValue({ dateFromRS: moment(moment.utc(approvalRS.PermitApprovedFrom).local()).toDate() });
              this.PTWForm.patchValue({ dateToRS: moment(moment.utc(approvalRS.PermitApprovedTo).local()).toDate() });
            }
            else if (approvalRS != undefined && !approvalRS.IsApproved) {
              this.PTWForm.get("btnRSReject").disable();
              this.PTWForm.patchValue({ remarksRS: approvalRS.Remarks });
              this.nameRS = this.loggedInUserJSON.FullName;
              this.designationRS = this.loggedInUserJSON.Designation;
            }
            else {
              this.nameRS = this.loggedInUserJSON.FullName;
              this.designationRS = this.loggedInUserJSON.Designation;
            }
          }
        }
        else {
          this.approvalRS = [];
          this.approvalPS = [];
          this.approvalExtension = [];
          this.approvalRS = response.Result.ApprovalDetails.find(element => element.ApprovalType == ApprovalType.ResponsibleSupervisor);
          this.approvalPS = response.Result.ApprovalDetails.find(element => element.ApprovalType == ApprovalType.ProductionSupervisor);
          this.approvalExtension = response.Result.ApprovalDetails.find(element => element.ApprovalType == ApprovalType.Extension);
          this.applyCancelation = response.Result.ApprovalDetails.find(element => element.ApprovalType == ApprovalType.CancellationApplied);
          this.approvalCancelation = response.Result.ApprovalDetails.find(element => element.ApprovalType == ApprovalType.CancellationApproval);
          if (this.approvalRS) {
            if (this.approvalRS.IsApproved) {
              this.showblockPS = true;
              this.PTWForm.get("btnRSApprove").disable();
              if (!this.permissions.PTW_Responsible_Supervisor && !this.permissions.PTW_Responsible_Supervisor_Unit) {
                this.PTWForm.get("btnRSReject").disable();
              }
              if (this.permissions.PTW_Admin || this.permissions.PTW_Admin_Unit) {
                this.PTWForm.get("btnRSReject").enable();
              }
              this.nameRS = this.allUsers.find(u => u.UserId == this.approvalRS.ApprovedBy).FullName;
              this.designationRS = this.allUsers.find(u => u.UserId == this.approvalRS.ApprovedBy).Designation;
              this.PTWForm.patchValue({ isDailyValidationAllowed: this.approvalRS.IsDailyPreValidation ? "true" : "false" });
              this.PTWForm.patchValue({ isHoursValidationAllowed: this.approvalRS.IsHoursValidation ? "true" : "false" });
              this.PTWForm.patchValue({ dateFromRS: moment(moment.utc(this.approvalRS.PermitApprovedFrom).local()).toDate() });
              this.PTWForm.patchValue({ dateToRS: moment(moment.utc(this.approvalRS.PermitApprovedTo).local()).toDate() });
              if (this.approvalPS != undefined && this.approvalPS.IsApproved) {
                this.showblockExtension = true;
                this.PTWForm.get("btnPSApprove").disable();
                if (!this.permissions.PTW_Production_Supervisor && !this.permissions.PTW_Production_Supervisor_Unit) {
                  this.PTWForm.get("btnPSReject").disable();
                }
                if (this.permissions.PTW_Admin || this.permissions.PTW_Admin_Unit) {
                  this.PTWForm.get("btnPSReject").enable();
                }
                this.namePS = this.allUsers.find(u => u.UserId == this.approvalPS.ApprovedBy).FullName;
                this.designationPS = this.allUsers.find(u => u.UserId == this.approvalPS.ApprovedBy).Designation;
                if (this.approvalExtension != undefined && this.approvalExtension.IsApproved) {
                  this.PTWForm.get("btnExtensionApprove").disable();
                  if (!this.permissions.PTW_Responsible_Supervisor && !this.permissions.PTW_Responsible_Supervisor_Unit) {
                    this.PTWForm.get("btnExtensionReject").disable();
                  }
                  if (this.permissions.PTW_Admin || this.permissions.PTW_Admin_Unit) {
                    this.PTWForm.get("btnExtensionReject").enable();
                  }
                  this.nameExtension = this.allUsers.find(u => u.UserId == this.approvalExtension.ApprovedBy).FullName;
                  this.designationExtension = this.allUsers.find(u => u.UserId == this.approvalExtension.ApprovedBy).Designation;
                  this.PTWForm.patchValue({ extensionValidTo: moment(moment.utc(this.approvalExtension.ExtensionValidTo).local()).toDate() });
                }
                else if (this.approvalExtension != undefined && !this.approvalExtension.IsApproved) // reject extension
                {
                  this.maxDateForExtension = moment(moment.utc(this.approvalRS.PermitApprovedTo).local()).toDate();
                  this.maxDateForExtension.setDate(this.maxDateForExtension.getDate() + 7);
                  this.minDateForExtension = moment(moment.utc(this.approvalRS.PermitApprovedTo).local()).toDate();
                  this.PTWForm.get("btnExtensionReject").disable();
                  if (!this.permissions.PTW_Responsible_Supervisor || !this.permissions.PTW_Responsible_Supervisor_Unit) {
                    this.PTWForm.get("btnExtensionApprove").disable();
                  }
                  if (this.permissions.PTW_Admin || this.permissions.PTW_Admin_Unit) {
                    this.PTWForm.get("btnExtensionApprove").enable();
                  }
                  this.PTWForm.patchValue({ remarksExtension: this.approvalExtension.Remarks });
                  // this.nameExtension = this.loggedInUserJSON.FullName;
                  // this.designationExtension = this.loggedInUserJSON.Designation;
                  this.PTWForm.patchValue({ extensionValidTo: moment(moment.utc(this.approvalRS.PermitApprovedTo).local()).toDate() });
                  if(!this.permissions.PTW_Admin && !this.permissions.PTW_Admin_Unit && !this.permissions.PTW_Responsible_Supervisor && !this.permissions.PTW_Responsible_Supervisor_Unit){
                    this.nameExtension = this.allUsers.find(u => u.UserId == this.approvalExtension.ApprovedBy).FullName;
                    this.designationExtension = this.allUsers.find(u => u.UserId == this.approvalExtension.ApprovedBy).Designation;
                  }
                }
                else {
                  this.maxDateForExtension = moment(moment.utc(this.approvalRS.PermitApprovedTo).local()).toDate();
                  this.maxDateForExtension.setDate(this.maxDateForExtension.getDate() + 7);
                  this.minDateForExtension = moment(moment.utc(this.approvalRS.PermitApprovedTo).local()).toDate();
                  this.nameExtension = this.loggedInUserJSON.FullName;
                  this.designationExtension = this.loggedInUserJSON.Designation;
                  this.PTWForm.get("btnExtensionReject").disable()
                  this.PTWForm.patchValue({ extensionValidTo: moment(moment.utc(this.approvalRS.PermitApprovedTo).local()).toDate() });
                }
              }
              else if (this.approvalPS != undefined && !this.approvalPS.IsApproved) // reject ps
              {
                // this.namePS = this.allUsers.find(u => u.UserId == this.approvalPS.ApprovedBy).FullName;
                // this.designationPS = this.allUsers.find(u => u.UserId == this.approvalPS.ApprovedBy).Designation;
                this.PTWForm.get("btnPSReject").disable()
                if (!this.permissions.PTW_Production_Supervisor && !this.permissions.PTW_Production_Supervisor_Unit) {
                  this.PTWForm.get("btnPSApprove").disable();
                  this.PTWForm.get("btnRSReject").disable();
                }
                if (this.permissions.PTW_Admin || this.permissions.PTW_Admin_Unit) {
                  this.PTWForm.get("btnPSApprove").enable();
                  this.PTWForm.get("btnRSReject").enable();
                }
                this.PTWForm.patchValue({ remarksPS: this.approvalPS.Remarks });
                if(!this.permissions.PTW_Admin && !this.permissions.PTW_Admin_Unit && !this.permissions.PTW_Production_Supervisor && !this.permissions.PTW_Production_Supervisor_Unit){
                  this.namePS = this.allUsers.find(u => u.UserId == this.approvalPS.ApprovedBy).FullName;
                  this.designationPS = this.allUsers.find(u => u.UserId == this.approvalPS.ApprovedBy).Designation;
                }
                else 
                {
                  this.namePS = this.loggedInUserJSON.FullName;
                  this.designationPS = this.loggedInUserJSON.Designation;

                }
              }
              else {
                this.namePS = this.loggedInUserJSON.FullName;
                this.designationPS = this.loggedInUserJSON.Designation;
              }
            }
            else if (this.approvalRS != undefined && !this.approvalRS.IsApproved) // reject rs
            {
              // this.nameRS = this.allUsers.find(u => u.UserId == this.approvalRS.ApprovedBy).FullName;
              // this.designationRS = this.allUsers.find(u => u.UserId == this.approvalRS.ApprovedBy).Designation;
              this.PTWForm.get("btnRSReject").disable();
              if (!this.permissions.PTW_Responsible_Supervisor && !this.permissions.PTW_Responsible_Supervisor_Unit) {
                this.PTWForm.get("btnRSApprove").disable();
              }
              if (this.permissions.PTW_Admin || this.permissions.PTW_Admin_Unit) {
                this.PTWForm.get("btnRSApprove").enable();
              }
              this.PTWForm.patchValue({ remarksRS: this.approvalRS.Remarks });
              if(!this.permissions.PTW_Admin && !this.permissions.PTW_Admin_Unit && !this.permissions.PTW_Production_Supervisor && !this.permissions.PTW_Production_Supervisor_Unit){
                this.nameRS = this.allUsers.find(u => u.UserId == this.approvalRS.ApprovedBy).FullName;
                this.designationRS = this.allUsers.find(u => u.UserId == this.approvalRS.ApprovedBy).Designation;
              }
              else 
              {
                this.nameRS = this.loggedInUserJSON.FullName;
                this.designationRS = this.loggedInUserJSON.Designation;
              }
            }
            else {
              this.nameRS = this.loggedInUserJSON.FullName;
              this.designationRS = this.loggedInUserJSON.Designation;
            }
          }
          if (this.applyCancelation) {
            this.showApproveCancelation = true;
            if (this.applyCancelation.IsApproved) {
              this.PTWForm.get("btnApplyCancellationApprove").disable();
              this.PTWForm.get("btnApplyCancellationReject").disable();
              if (!(this.loggedInUserJSON.UserId == this.SelectedUserId)) {
                this.PTWForm.get("btnApplyCancellationReject").disable();
              }
              if (this.permissions.PTW_Admin || this.permissions.PTW_Admin_Unit) {
                this.PTWForm.get("btnApplyCancellationReject").enable();
              }
            }
            else {
              this.PTWForm.get("btnApplyCancellationReject").disable();
              if (!(this.loggedInUserJSON.UserId == this.SelectedUserId)) {
                this.PTWForm.get("btnApplyCancellationApprove").disable();
              }
              if (this.permissions.PTW_Admin || this.permissions.PTW_Admin_Unit) {
                this.PTWForm.get("btnApplyCancellationApprove").enable();
              }
            }
            this.nameCanclePermitHolder = this.allUsers.find(u => u.UserId == this.applyCancelation.ApprovedBy).FullName;
            this.designationCanclePermitHolder = this.allUsers.find(u => u.UserId == this.applyCancelation.ApprovedBy).Designation;
            this.dateCanclePermitHolder = moment(moment.utc(this.applyCancelation.CreatedDate).local()).toDate();
            this.statusApplyCanclePermit = this.applyCancelation.IsApproved ? "WORK COMPLETED" : "WORK NOT COMPLETED";
            if (this.approvalCancelation) {
              this.nameCanclePermitAA = this.allUsers.find(u => u.UserId == this.approvalCancelation.ApprovedBy).FullName;
              this.designationCanclePermitAA = this.allUsers.find(u => u.UserId == this.approvalCancelation.ApprovedBy).Designation;
              this.PTWForm.patchValue({ isEquipmentSafeCondition: this.approvalCancelation.IsEquipmentSafeCondition ? "true" : "false" });
              this.PTWForm.patchValue({ isWorksiteSafeAndClear: this.approvalCancelation.IsWorksiteSafeAndClear ? "true" : "false" });
              this.PTWForm.patchValue({ isReinstatementsComplete: this.approvalCancelation.IsReinstatementsComplete ? "true" : "false" });

              if (this.approvalCancelation.IsApproved) {
                this.PTWForm.get("btnCancellationApprove").disable();
                this.PTWForm.get("btnCancellationReject").disable();
                if (!this.permissions.PTW_Area_Authority && !this.permissions.PTW_Area_Authority_Unit) {
                  this.PTWForm.get("btnCancellationReject").disable();
                }
                if (this.permissions.PTW_Admin || this.permissions.PTW_Admin_Unit) {
                  this.PTWForm.get("btnCancellationReject").enable();
                }
              }
              else {
                this.PTWForm.get("btnCancellationReject").disable();
                if (!this.permissions.PTW_Area_Authority && !this.permissions.PTW_Area_Authority_Unit) {
                  this.PTWForm.get("btnCancellationApprove").disable();
                }
                if (this.permissions.PTW_Admin || this.permissions.PTW_Admin_Unit) {
                  this.PTWForm.get("btnCancellationApprove").enable();
                }
              }

              this.PTWForm.patchValue({ remarksCancellation: this.approvalCancelation.Remarks });
            }
            else {
              this.nameCanclePermitAA = this.loggedInUserJSON.FullName;
              this.designationCanclePermitAA = this.loggedInUserJSON.Designation;
            }
          }
        }
      }
      if (response.Result.PTWRequestDetails.SafetyEnvironmentPlan) {
        this.SafetyEnvironmentPlanFiles = response.Result.PTWRequestDetails.SafetyEnvironmentPlan;
      }

      if (this.isPermitJob) {
        if (response.Result.PTWRequestDetails.VehicleEntryChecklist) {
          this.VehicleEntryChecklistFiles = response.Result.PTWRequestDetails.VehicleEntryChecklist;
        }
        if (this.PTWForm.value.GasTestedForHC ||
          this.PTWForm.value.GasTestedForH2S ||
          this.PTWForm.value.GasTestedForO2 ||
          this.PTWForm.value.GasTestedForOther) {
          this.isGasTestVisible = true;
          this.gasRecordInitialText = '';
          let str = "";
          this.gasRecordInitialText = str.concat(this.PTWForm.value.GasTestedForHC ? "Hydrocarbon - \n" : "",
            this.PTWForm.value.GasTestedForH2S ? "H2S - \n" : "",
            this.PTWForm.value.GasTestedForO2 ? "Oxygen - \n" : "",
            this.PTWForm.value.GasTestedForOther ? this.PTWForm.value.GasTestSpecify + " - \n" : ""
          );
          this.gasTestRecords = [];
          this.gasTestLastRecordId = response.Result.PTWGasTestRecordDetails.length > 0 ?
            response.Result.PTWGasTestRecordDetails[0].LastRecordId : 1;

          response.Result.PTWGasTestRecordDetails.forEach(element => {
            let GasTestRecord = new PTWGasTestRecord();
            GasTestRecord.id = element.id;
            GasTestRecord.date = moment(moment.utc(element.Date).local()).toDate();
            GasTestRecord.result = element.result;
            GasTestRecord.user = element.user;
            GasTestRecord.PermitId = this.permitId;
            this.gasTestRecords.push(GasTestRecord);
          });
        }
        this.PTWForm.patchValue({ oncomingHolders: response.Result.PTWRequestDetails.oncomingHolders });
        this.isApplicant = this.loggedInUserJSON.UserId == this.SelectedUserId;
        this.isOncomingUser = response.Result.PTWRequestDetails.oncomingHolders.includes(this.loggedInUserJSON.UserId);
        this.isOncomingUserAndApplicant = this.isOncomingUser || this.isApplicant;
      }
      this.isApplicant = this.loggedInUserJSON.UserId == this.SelectedUserId;
      if (response.Result.Certificates) {
        for (let item of response.Result.Certificates) {
          this.Certificates.find(s => s.CertificateType == item.CertificateType).Files = item.Files;
          this.Certificates.find(s => s.CertificateType == item.CertificateType).IsApproved = item.IsApproved;
          this.Certificates.find(s => s.CertificateType == item.CertificateType).Remarks = item.Remarks;
          this.Certificates.forEach(s => {
            if (s.Files.length > 0) {
              s.IsRequired = true;
            }
          })
        }
      }
      if (this.Certificates.find(s => s.IsApproved == false)) {
        this.isCertificateApproved = true;
        this.PTWForm.get("btnRSApprove").disable();
      }
    }
    this.masterscreenService.setUpdatedData(
      JSON.stringify(this.ptwRequest.PTWRequestDetails),
      "UpdateAction"
    );

    this.masterscreenService.setOldPTWCertificates(
      JSON.stringify(this.Certificates),
      "oldPTWCertificates"
    );
    this.masterscreenService.setoldPTWgasTestRecords(
      JSON.stringify(this.gasTestRecords),
      "PTWgasTestRecords"
    );
    const oldPTWApprovalDetails = {
      Model: {
        "IsDailyValidationAllowed": this.PTWForm.value.isDailyValidationAllowed,
        "IsHoursValidationAllowed": this.PTWForm.value.isHoursValidationAllowed,
        "PermitApprovedFromDate": this.PTWForm.value.dateFromRS,
        "PermitApprovedToDate": this.PTWForm.value.dateToRS,
        "ResponsibleSupervisorRemark": this.PTWForm.value.remarksRS,
        "ExtensionValidUpto": this.PTWForm.value.extensionValidTo,
        "ExtensionAuthorizationRemark": this.PTWForm.value.remarksExtension,
        "ProductionSupervisorRemark": this.PTWForm.value.remarksPS
      },
    };
    this.masterscreenService.setoldPTWAuthorizationData(
      JSON.stringify(oldPTWApprovalDetails),
      "PTWAuthorizationData"
    );
   
    this.getPermissionDetails(this.unitId);
    this.baseService.showRootLoader = false;

    this.permitIds = this.PTWService.getAllPTWRequestIds(); 
    if(this.permitIds == null){
      this.isNext = false;
      this.isPrevious = false;
    }
  
    let currentIndex: number = 0;
    if (this.permitIds) {
      this.permitIds.forEach((element, index) => {
        if (element.PermitId === this.permitId) {
          currentIndex = index;
          return;
        }
      });
      if (currentIndex === 0) {
        this.isPrevious = false;
      }
      if (currentIndex === this.permitIds.length - 1) {
        this.isNext = false;
      }
    }
    // console.log(this.isUpdate);
    // console.log(this.permitStatus !== PermitStatus.Draft);
    // console.log(this.PTWForm.get('IsAgreeFrozenPlan').value && this.isPermitJob) 
    // console.log( this.isPermitJob) ;
    // console.log(this.isApplicant )
    // console.log(this. permitStatus == PermitStatus.PendingForAuthorization);
    // console.log(this.permitStatus == PermitStatus.RejectedByRS);
    // console.log(this. permitStatus == PermitStatus.RejectedByPS )
    // console.log(this.permissions.PTW_Admin);
    // console.log(this.permissions.PTW_Admin_Unit);

   
  }
  getUnits() {
    const apiRequestUnit = {
      Model: {
        ModuleId: ConstantsService.PermissionMatrixModules.PTW,
        UserId: this.loggedInUserJSON.UserId,
        IsActive : this.IsNewRecord
      }
    };
    this.masterscreenService.getUnits(
      apiRequestUnit,
      this.callbackMethodForUnitDetails.bind(this)
    );
  }
  onGasRecordUpdate(records) {
    this.gasTestRecords = records;

  }
  setUsersData() {
    this.searchTexts.UserTypeId = 0;
    this.searchTexts.FilterTexts = "";
    this.searchTexts.CompanyId = 0;
    this.searchTexts.UnitId = -1;
    const apiRequest = {
      Model: this.searchTexts
    };
    this.commonService.getSearchResultsForUsers(apiRequest, this.callbackMethodForGetSearchResultsForUsers.bind(this));
  }
  callbackMethodForGetSearchResultsForUsers(response) {
    if (response.Success) {
      this.allUsers = response.Result;
      this.allUsersData = [];
      this.allUsers.forEach(s =>
        this.allUsersData.push({
          label: s.FullName,
          value: s.UserId
        })
      );
      this.checkIsUpdateProcess();
    }
  }

  certiticateRequiredChanges(event, index): void {
    this.Certificates[index].IsRequired = event.target.checked;
    this.Certificates[index].IsApproved = event.target.checked;
    this.Certificates[index].RemarkRequired = false;
    this.Certificates[index].UploadRequired = false;
  }

  onDurationFromDateChange(permitType) {
    let permit = "";
    if(permitType == null || permitType == undefined)
    {
      if(this.PTWForm.value.PermitType != null && this.PTWForm.value.PermitType != undefined)
      {
        if(this.PTWForm.value.PermitType.trim() == "Class A (Red Edge Permit)")
        {
          permit = "1";
        }
        else if(this.PTWForm.value.PermitType.trim() == "Class B (Blue Edge Permit)")
        {
          permit = "2";
        }
      }
    }
    else
    {
      permit = permitType;
    }
    if (this.isPermitJob) {
      if (permit == PermitType.RedEdge.toString()) {
        this.tillToDateForDuration = moment(moment.utc(this.PTWForm.get('DateFrom').value).local()).toDate();
        this.tillToDateForDuration.setDate(this.tillToDateForDuration.getDate() + 14);
      }
      else if (permit == PermitType.BlueEdge.toString()) {
        this.tillToDateForDuration = moment(moment.utc(this.PTWForm.get('DateFrom').value).local()).toDate();
        this.tillToDateForDuration.setDate(this.tillToDateForDuration.getDate() + 21);
      }
      else
      {
        this.tillToDateForDuration = moment(moment.utc(this.PTWForm.get('DateFrom').value).local()).toDate();
        this.tillToDateForDuration.setDate(this.tillToDateForDuration.getDate() + 21);
      }
    }
    else {
      this.tillToDateForDuration = moment(moment.utc(this.PTWForm.get('DateFrom').value).local()).toDate();
      this.tillToDateForDuration.setDate(this.tillToDateForDuration.getDate() + 21);
    }
  }

  onRSFromDateChange(permitType) {
    let permit = "";
    if(permitType == null || permitType == undefined)
    {
      if(this.PTWForm.value.PermitType != null && this.PTWForm.value.PermitType != undefined)
      {
        if(this.PTWForm.value.PermitType.trim() == "Class A (Red Edge Permit)")
        {
          permit = "1";
        }
        else if(this.PTWForm.value.PermitType.trim() == "Class B (Blue Edge Permit)")
        {
          permit = "2";
        }
      }
    }
    else
    {
      permit = permitType;
    }
    if (this.isPermitJob) {
      if (permit == PermitType.RedEdge.toString()) {
        this.tillToDateForRS = moment(moment.utc(this.PTWForm.get('dateFromRS').value).local()).toDate();
        this.tillToDateForRS.setDate(this.tillToDateForRS.getDate() + 14);
      }
      else if (permit == PermitType.BlueEdge.toString()) {
        this.tillToDateForRS = moment(moment.utc(this.PTWForm.get('dateFromRS').value).local()).toDate();
        this.tillToDateForRS.setDate(this.tillToDateForRS.getDate() + 21);
      }
      else
      {
        this.tillToDateForRS = moment(moment.utc(this.PTWForm.get('dateFromRS').value).local()).toDate();
        this.tillToDateForRS.setDate(this.tillToDateForRS.getDate() + 21);
      }
    }
    else {
      this.tillToDateForRS = moment(moment.utc(this.PTWForm.get('dateFromRS').value).local()).toDate();
      this.tillToDateForRS.setDate(this.tillToDateForRS.getDate() + 21);
    }
  }
  saveApprovals(type, approval) {
    this.baseService.showRootLoader = true;
    if (type == ApprovalType.ResponsibleSupervisor && approval == true && this.PTWForm.get('dateToRS').value == null) {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Please Add Correct Date and time for Approval"
      );
      this.baseService.showRootLoader = false;
      this.hseErrorHandler.handleError("Please Add Correct Date and time for Approval");
    }
    else {
      let ptwApprovals = new PTWApprovals();
      ptwApprovals.PermitId = this.permitId;
      ptwApprovals.ApprovalType = type;
      ptwApprovals.ApprovedBy = this.loggedInUserJSON.UserId;
      ptwApprovals.IsApproved = approval;
      ptwApprovals.IsDailyPreValidation = this.PTWForm.value.isDailyValidationAllowed;
      ptwApprovals.IsHoursValidation = this.PTWForm.value.isHoursValidationAllowed;
      ptwApprovals.IsEquipmentSafeCondition = this.PTWForm.value.isEquipmentSafeCondition;
      ptwApprovals.IsWorksiteSafeAndClear = this.PTWForm.value.isWorksiteSafeAndClear;
      ptwApprovals.IsReinstatementsComplete = this.PTWForm.value.isReinstatementsComplete;

      if (approval == false && type == ApprovalType.ResponsibleSupervisor) {
        if (this.PTWForm.value.remarksRS == null) {
          this.notificationsService.toastNotify(
            "error",
            "Error Message",
            "Please add Remark for Reject"
          );
          this.baseService.showRootLoader = false;
          this.hseErrorHandler.handleError("Please add Remark for Reject");
        }
        else {
          ptwApprovals.Remarks = this.PTWForm.value.remarksRS;
        }
      }
      else if (approval == false && type == ApprovalType.ProductionSupervisor) {
        if (this.PTWForm.value.remarksPS == null) {
          this.notificationsService.toastNotify(
            "error",
            "Error Message",
            "Please add Remark for Reject"
          );
          this.baseService.showRootLoader = false;
          this.hseErrorHandler.handleError("Please add Remark for Reject");
        }
        else {
          ptwApprovals.Remarks = this.PTWForm.value.remarksPS;
        }
      }
      else if (approval == false && type == ApprovalType.Extension) {
        if (this.PTWForm.value.remarksExtension == null) {
          this.notificationsService.toastNotify(
            "error",
            "Error Message",
            "Please add Remark for Reject"
          );
          this.baseService.showRootLoader = false;
          this.hseErrorHandler.handleError("Please add Remark for Reject");
        }
        else {
          ptwApprovals.Remarks = this.PTWForm.value.remarksExtension;
        }
      }
      else if (approval == false && type == ApprovalType.CancellationApproval) {
        if (this.PTWForm.value.remarksCancellation == null) {
          this.notificationsService.toastNotify(
            "error",
            "Error Message",
            "Please add Remark for Reject"
          );
          this.baseService.showRootLoader = false;
          this.hseErrorHandler.handleError("Please add Remark for Reject");
        }
        else {
          ptwApprovals.Remarks = this.PTWForm.value.remarksCancellation;
        }
      }
      else {
        ptwApprovals.Remarks = "";
      }
      ptwApprovals.PermitApprovedFrom = moment(moment.utc(this.PTWForm.value.dateFromRS).local()).toDate();
      ptwApprovals.PermitApprovedTo = moment(moment.utc(this.PTWForm.value.dateToRS).local()).toDate();
      ptwApprovals.ExtensionValidTo = moment(moment.utc(this.PTWForm.value.extensionValidTo).local()).toDate();
      ptwApprovals.CreatedDate = moment(moment.utc(new Date()).local()).toDate();
      this.oldPTWAuthorizationData = JSON.parse(
        this.masterscreenService.getoldPTWAuthorizationData("PTWAuthorizationData")
      );
      this.trackApprovalDetails(type,this.oldPTWAuthorizationData,ptwApprovals);
      this.PTWService.saveApprovals({ Model: ptwApprovals }, this.callbackMethodForSaveApprovals.bind(this));
    }
  }
  callbackMethodForSaveApprovals(response) {
    if (response.Success) {
      this.notificationsService.toastNotify(
        "success",
        "Success Message",
        "PTW Approval Updated successfully"
      );
      this.baseService.showRootLoader = false;
      window.location.reload();
    }
    else {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something went wrong. Approval not Updated."
      );
      this.baseService.showRootLoader = false;
      this.hseErrorHandler.handleError(response.Errors);
    }
  }

  getCertificateRequired() {
    this.requiredCertificates = this.activityMatrixList.find(s => parseInt(s.SubActivity) == this.activityMatrixId).RequiredCertificates;
    this.requiredCertificates.forEach(element => {
      let index = this.Certificates.findIndex(s => s.CertificateType == element);
      if (index > -1) {
        this.Certificates[index].IsRequired = true;
        this.Certificates[index].IsDisabled = true;
      }
    });
  }
  onRemarkChange(event, i) {
    this.Certificates[this.Certificates.findIndex(s => s.CertificateType == i)].RemarkRequired = false;
    this.Certificates[this.Certificates.findIndex(s => s.CertificateType == i)].Remarks = event.target.value;
  }

  uploadGasTestRecords() {
    const apiRequest = {
      Model: {
        PTWGasTestRecord: this.gasTestRecords
      }
    };
    this.PTWService.saveGasTestRecords(apiRequest, this.callbackMethodForGasTestRecords.bind(this));
  }

  callbackMethodForGasTestRecords(response) {
    if (response.Success) {
      this.oldPTWgasTestRecords = JSON.parse(
        this.masterscreenService.getoldPTWgasTestRecords("PTWgasTestRecords")
      );
      this.trackDetailsForInternalUpdate("PTWgasTestRecords",this.oldPTWgasTestRecords,this.gasTestRecords);
      this.notificationsService.toastNotify(
        "success",
        "Success Message",
        "Records Updated successfully"
      );
      window.location.reload();
    }
    else {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something went wrong. Please add at least 1 record."
      );
      this.baseService.showRootLoader = false;
      this.hseErrorHandler.handleError(response.Errors);
    }
  }


  onTableRecordsUpdate(records, RecordType) {
    this.allTablesEmitedRecords = [];

    if (RecordType == AllTableRecordType.TRICTalk) {
      this.IsPTWTRICRecordsEdited = true;
      if (records.length != 0) {
        this.TRICTableRecords = records;
        this.IsTRICTableRecords = true;
      }
    }
    if (RecordType != AllTableRecordType.TRICTalk && RecordType != undefined) {
      if(RecordType == AllTableRecordType.OtherAffectedCustodian)
      {
        this.IsPTWOAFRecordsEdited = true;
      }
      else if(RecordType == AllTableRecordType.SafetyCoordination)
      {
        this.IsPTWSafetyRecordsEdited = true;
      }
      else if(RecordType == AllTableRecordType.Validation)
      {
        this.IsPTWValidationRecordsEdited = true;
      }
      else if(RecordType == AllTableRecordType.Acceptance)
      {
        this.IsPTWAcceptanceRecordsEdited = true;
      }
      else if(RecordType == AllTableRecordType.Suspension)
      {
        this.IsPTWSuspensionRecordsEdited = true;
      }
      if (records.length == 0) {
        this.allTablesEmitedRecords.push(
          {
            id: 0,
            PermitId: this.permitId,
            RecordType: RecordType,
            IsApproved: false,
            Remarks: "",
            ValidationTimeFrom: moment(moment.utc(new Date()).local()).toDate(),
            ValidationTimeTo: moment(moment.utc(new Date()).local()).toDate(),
            user: this.loggedInUserJSON.UserId,
            date: moment(moment.utc(new Date()).local()).toDate(),
            username: this.loggedInUserJSON.FullName,
            designation: this.loggedInUserJSON.Designation
          }
        )
      }
      else {
        this.allTablesEmitedRecords = records;
        this.IsTRICTableRecords = false;
      }
    }
  }

  uploadAllTablesRecords() {
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        PTWAllTableRecords: this.allTablesEmitedRecords,
        TRICTableRecords: this.TRICTableRecords,
        IsTRICTableRecords: this.IsTRICTableRecords
      }
    };
    this.PTWService.saveAllTablesRecords(apiRequest, this.callbackMethodForOACRecords.bind(this));
  }
  callbackMethodForOACRecords(response) {
    if (response.Success) {
      this.oldPTWOAFRecords = JSON.parse(
        this.masterscreenService.getoldPTWOAFRecords("PTWOAFRecords")
      );
      this.trackDetailsForInternalUpdate("PTWOAFRecords",this.oldPTWOAFRecords,this.allTablesEmitedRecords.filter(u => u.RecordType == AllTableRecordType.OtherAffectedCustodian));

      this.oldPTWTRICTableRecords = JSON.parse(
        this.masterscreenService.getoldPTWTRICTableRecords("PTWTRICTableRecords")
      );
      this.trackDetailsForInternalUpdate("PTWTRICTableRecords",this.oldPTWTRICTableRecords,this.TRICTableRecords);

      this.oldPTWSafetyRecords = JSON.parse(
        this.masterscreenService.getoldPTWSafetyRecords("PTWSafetyRecords")
      );
      this.trackDetailsForInternalUpdate("PTWSafetyRecords",this.oldPTWSafetyRecords,this.allTablesEmitedRecords.filter(u => u.RecordType == AllTableRecordType.SafetyCoordination));

      this.oldPTWValidationRecords = JSON.parse(
        this.masterscreenService.getoldPTWValidationRecords("PTWValidationRecords")
      );
      this.trackDetailsForInternalUpdate("PTWValidationRecords",this.oldPTWValidationRecords,this.allTablesEmitedRecords.filter(u => u.RecordType == AllTableRecordType.Validation));

      this.oldPTWAcceptanceRecords = JSON.parse(
        this.masterscreenService.getoldPTWAcceptanceRecords("PTWAcceptanceRecords")
      );
      this.trackDetailsForInternalUpdate("PTWAcceptanceRecords",this.oldPTWAcceptanceRecords,this.allTablesEmitedRecords.filter(u => u.RecordType == AllTableRecordType.Acceptance));

      this.oldPTWSuspensionRecords = JSON.parse(
        this.masterscreenService.getoldPTWSuspensionRecords("PTWSuspensionRecords")
      );
      this.trackDetailsForInternalUpdate("PTWSuspensionRecords",this.oldPTWSuspensionRecords,this.allTablesEmitedRecords.filter(u => u.RecordType == AllTableRecordType.Suspension));

      this.notificationsService.toastNotify(
        "success",
        "Success Message",
        "Records Updated successfully"
      );
      this.baseService.showRootLoader = false;
      window.location.reload();
    }
    else {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something went wrong. Please add at least 1 record."
      );
      this.baseService.showRootLoader = false;
      this.hseErrorHandler.handleError(response.Errors);
    }
    this.DisableRecordsEditedPropertyForTableData();
  }
  downloadTemplate(files) {
    files.forEach(element => {
      saveAs(element.FilePath);
    });
  }
  GetRecordsForAllTables() {
    const apiRequest = {
      Model: {
        PermitId: this.permitId
      }
    };
    this.PTWService.getAllTablesRecords(apiRequest, this.callbackMethodForGetRecordsForAllTables.bind(this));
  }
  callbackMethodForGetRecordsForAllTables(response) {
    if (response.Success) {
      this.allTablesRecords = [];
      this.allTablesLastRecordId = response.Result.length > 0 ?
        response.Result[0].LastRecordId : 1;

      response.Result.forEach(element => {
        let AllTablesRecord = new PTWTablesRecords();
        AllTablesRecord.id = element.Id;
        AllTablesRecord.PermitId = this.permitId;
        AllTablesRecord.RecordType = element.RecordType;
        AllTablesRecord.IsApproved = element.IsApproved;
        AllTablesRecord.Remarks = element.Remarks;
        AllTablesRecord.user = element.CreatedBy;
        AllTablesRecord.date = moment(moment.utc(element.CreatedDate).local()).toDate();
        AllTablesRecord.ValidationTimeFrom = moment(moment.utc(element.ValidationTimeFrom).local()).toDate();
        AllTablesRecord.ValidationTimeTo = moment(moment.utc(element.ValidationTimeTo).local()).toDate();
        this.allTablesRecords.push(AllTablesRecord);
      });
      if (this.allTablesRecords.length > 0) {
        this.SafetyRecords = this.allTablesRecords.filter(s => s.RecordType == AllTableRecordType.SafetyCoordination).sort(a=>a.date.getDate());
        this.AcceptanceRecords = this.allTablesRecords.filter(s => s.RecordType == AllTableRecordType.Acceptance).sort(a=>a.date.getDate());
        this.SuspensionRecords = this.allTablesRecords.filter(s => s.RecordType == AllTableRecordType.Suspension).sort(a=>a.date.getDate());
        this.OAFRecords = this.allTablesRecords.filter(s => s.RecordType == AllTableRecordType.OtherAffectedCustodian).sort(a=>a.date.getDate());
        this.ValidationRecords = this.allTablesRecords.filter(s => s.RecordType == AllTableRecordType.Validation).sort(a=>a.ValidationTimeFrom.getDate());
        if ((this.SafetyRecords && this.SafetyRecords.length) || (this.ValidationRecords && this.ValidationRecords.length)) {
            this.showOtherTables = true
        }
        else {
          this.showOtherTables = false
        }
      }
      this.masterscreenService.setoldPTWOAFRecords(
        JSON.stringify(this.OAFRecords),
        "PTWOAFRecords"
      );
      this.masterscreenService.setoldPTWSafetyRecords(
        JSON.stringify(this.SafetyRecords),
        "PTWSafetyRecords"
      );
      this.masterscreenService.setoldPTWValidationRecords(
        JSON.stringify(this.ValidationRecords),
        "PTWValidationRecords"
      );
      this.masterscreenService.setoldPTWAcceptanceRecords(
        JSON.stringify(this.AcceptanceRecords),
        "PTWAcceptanceRecords"
      );
      this.masterscreenService.setoldPTWSuspensionRecords(
        JSON.stringify(this.SuspensionRecords),
        "PTWSuspensionRecords"
      );
    }
  }

  onPreviousClick() {
    this.permitIndex = -1;
    this.isNext = true;
    this.disablePermit = false;
    this.permitIds = this.PTWService.getAllPTWRequestIds();
    if (this.permitIds) {
      this.permitIds.forEach((element, index) => {
        if (element.PermitId === this.permitId && index - 1 != null) {
          this.permitIndex = index - 1;
          if (this.permitIndex <= 0) {
            this.isPrevious = false;
          } else {
            this.isPrevious = true;
          }
          return;
        }
      });
    }
    if (this.permitIndex > -1) {
      this.permitId = this.permitIds[
        this.permitIndex
      ].PermitId;
      this.unitId = this.permitIds[this.permitIndex].UnitId;
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          PermitId: this.permitId,
        },
      };
      this.PTWService.getPTWRequestByPermitId(
        apiRequest,
        this.callbackMethodForGetRequestByPermitId.bind(this)
      );
      this.router.navigate(
        ['/ptw/raise-permit/', this.permitId], { queryParams: { unitId: this.unitId } }
      );
    }
  }

  onNextClick() {
    this.isPrevious = true;
    this.permitIndex = -1;
    this.disablePermit = false;
    this.permitIds = this.PTWService.getAllPTWRequestIds();
    if (this.permitIds) {
      this.permitIds.forEach((element, index) => {
        if (element.PermitId === this.permitId && index + 1 != null) {
          this.permitIndex = index + 1;
          if (this.permitIndex + 1 == this.permitIds.length) {
            this.isNext = false;
          } else {
            this.isNext = true;
          }
          return;
        }
      });
    }
    if (this.permitIndex > -1) {
      this.permitId = this.permitIds[
        this.permitIndex
      ].PermitId;
      this.unitId = this.permitIds[this.permitIndex].UnitId;
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          PermitId: this.permitId,
        },
      };
      this.PTWService.getPTWRequestByPermitId(
        apiRequest,
        this.callbackMethodForGetRequestByPermitId.bind(this)
      );
      this.router.navigate(
        ['/ptw/raise-permit/', this.permitId], { queryParams: { unitId: this.unitId } }
      );
    }
  }

  GetTRICTableRecords() {
    const apiRequest = {
      Model: {
        PermitId: this.permitId
      }
    };
    this.PTWService.getTRICTablesRecords(apiRequest, this.callbackMethodForGetRecordsForTRICTable.bind(this));
  }
  callbackMethodForGetRecordsForTRICTable(response) {
    if (response.Success) {
      this.TRICTableRecords = [];

      this.TRICTableLastRecordId = response.Result.length > 0 ?
        response.Result[0].LastRecordId : 1;

      response.Result.forEach(element => {
        let TRICTableRecord = new TRICRecords();
        TRICTableRecord.id = element.Id;
        TRICTableRecord.PermitId = this.permitId;
        TRICTableRecord.RecordType = element.RecordType;
        TRICTableRecord.NoOfWorkParty = element.NoOfWorkParty;
        TRICTableRecord.user = element.CreatedBy;
        TRICTableRecord.date = moment(moment.utc(element.CreatedDate).local()).toDate();
        TRICTableRecord.Attendee = element.Attendee;
        this.TRICTableRecords.push(TRICTableRecord);
      });
      let Record = this.TRICTableRecords.find(s => s.Attendee.length > 0);
      if (Record) {
        this.AttendeeTableLastRecordId = Record.Attendee.length > 0 ?
          Record.Attendee[0].LastRecordId : 1;
      }
      if (this.TRICTableRecords.length > 0) {
        this.showSafetyTable = true;
      }
      this.masterscreenService.setoldPTWTRICTableRecords(
        JSON.stringify(this.TRICTableRecords),
        "TRICTableRecords"
      );
    }
  }

  downloadPDF() {
    this.notificationsService.toastNotify('info', 'Information Message', 'Download is in Progress!');
    const apiRequest = {
      Model: {
        ProcessName: "PTW",
        SourceId: this.permitId
      }
    };
    this.PTWService.downloadPDF(apiRequest, this.callbackMethodForDownloadPDF.bind(this));
  }

  callbackMethodForDownloadPDF(response) {
    if (response) {
      var fileDownLoadName = `pdf_permit_${this.permitId}.pdf`;
      FileUtility.downloadPDF(response, fileDownLoadName);

    }
  }

  IsAddRecordsForTRICTalk() {
    if (this.permissions.PTW_Admin || this.permissions.PTW_Admin_Unit || ((this.SelectedUserId == this.loggedInUserJSON.UserId || this.isOncomingUser) && !this.disablePTW)) {
      return true;
    }
    else{
      return false;
    }
  }

  onOkClickedForConfirmation() {
    this.dialogType = "";
    this.alertType = "";
  }
  onYesClickedForConfirmation() {
    switch (this.dialogType) {
      case "AdminUpdatePermit":
        this.submitApplyPermit();
        break;
      case "ConfirmReset":
        window.location.reload();
        break;
    }
    this.dialogType = "";
    this.alertType = "";
  }
  onNoClickedForConfirmation() {
    switch (this.dialogType) {
      case "AdminUpdatePermit":
        break;
      case "ConfirmReset":
        break;
    }
    this.dialogType = "";
    this.alertType = "";
  }
  getOutput(event) {
    if (event) {
      this.router.navigate(["ptw/permit-overview"]);
    }
  }
  downloadFile(url) {
    saveAs(url);
  }
  selectFile(fileUrl) {
    this.currentFileUrl = fileUrl;
  }
  groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  isOACUser(allTablesRecords) {
    if (allTablesRecords) {
      allTablesRecords.forEach(element => {
        if (element.RecordType = AllTableRecordType.OtherAffectedCustodian) {
          this.OAFRecordsUserList.push(element.user)
        }
      });

      if (this.OAFRecordsUserList.includes(this.loggedInUserJSON.UserId)) {
        return true;
      }
      else {
        return false;
      }
    }
  }
  
  //BOC Pritesh
  saveAsDraft() {
    this.baseService.showRootLoader = true;
    this.Certificates.forEach(element => {
      if (element.IsRequired == true && element.Files.length == 0) {
        this.Certificates[this.Certificates.findIndex(s => s.CertificateType == element.CertificateType)].UploadRequired = true;
      }
      else {
        this.Certificates[this.Certificates.findIndex(s => s.CertificateType == element.CertificateType)].UploadRequired = false;
      }
      if (element.IsApproved == false && (element.Remarks == "" || element.Remarks == undefined) && element.Files.length > 0) {
        this.Certificates[this.Certificates.findIndex(s => s.CertificateType == element.CertificateType)].RemarkRequired = true;
      }
      else {
        this.Certificates[this.Certificates.findIndex(s => s.CertificateType == element.CertificateType)].RemarkRequired = false;
      }
    });

    if (this.Certificates.find(s => s.RemarkRequired == true)) {
      this.isAllValid = false
    }
    else if (this.Certificates.find(s => s.UploadRequired == true)) {
      this.isAllValid = false;
    }
    else if(!this.PTWForm.value.oncomingHolders && this.isPermitJob){
      this.isAllValid = false;
    }
    else if ((this.VehicleEntryChecklistFiles.length <= 0 && this.isPermitJob && this.PTWForm.value.IsVehicleRequired == "true") || this.SafetyEnvironmentPlanFiles.length <= 0) {
      if (this.VehicleEntryChecklistFiles.length <= 0 && this.isPermitJob && this.PTWForm.value.IsVehicleRequired == "true") {
        this.invalidVehicleEntry = true;
        this.isAllValid = false;
      }
      if (this.SafetyEnvironmentPlanFiles.length <= 0) {
        this.invalidEnvironmentPlan = true;
        this.isAllValid = false;
      }
    }
    else {
      this.invalidVehicleEntry = false;
      this.invalidEnvironmentPlan = false;
      this.isAllValid = true;
    }
    if (this.PTWForm.valid && this.isAllValid) {
      const apiRequest = {
        Model: {
          PTWRequestPostDetails: {
            "PermitId": this.permitId,
            "UnitId": this.selectedUnit.UnitId,
            "PermitType": this.permit,
            "LocationId": this.PTWForm.value.unitLocation,
            "Activity": this.PTWForm.value.SelectedSubActivity,
            "ProcessFacility": this.PTWForm.get('IsProcessFacility').value,
            "HydrocarbonArea": this.PTWForm.get('IsHydrocarbonArea').value,
            "HazardousArea": this.PTWForm.get('HazardousZones').value ? this.PTWForm.get('HazardousZones').value.map(Number) : [0],
            "GasTestrequiredBeforeWorkStart": this.PTWForm.get('IsGasTestBeforeAfterDay').value,
            "GasTestrequiredEveryTwoHr": this.PTWForm.get('IsGasTestEveryTwoHour').value,
            "GasMonitoringRequired": this.PTWForm.get('IsContinueGasMonitoring').value,
            "SafetyEquipmentRequired": this.PTWForm.get('IsSafetyEquipment').value,
            "GasTestInterval": this.PTWForm.value.GasTestInterval,
            "AdditionalComment": this.PTWForm.get('AdditionalComments').value,
            "PermitNumber": this.PTWForm.value.PTWNumber,
            "ExactLocation": this.PTWForm.value.ExactLocation,
            "WorkSite": this.PTWForm.value.Worksite,
            "WorkDescription": this.PTWForm.value.WorkDescription,
            "NORMContaminatedArea": this.PTWForm.value.IsNORMContaminatedArea,
            "MercuryPotential": this.PTWForm.value.IsMercuryPotential,
            "H2SFacilityClassification": this.PTWForm.value.H2SFacilityClassification,
            "ExpectedMaxPPM": this.PTWForm.value.ExpectedMaxPPM,
            "AssociatedPTWNo": this.PTWForm.value.AssociatedPTWno,
            "WorkOrderNumber": this.PTWForm.value.EWPno,
            "GasHydrocarbon": this.PTWForm.value.GasTestedForHC,
            "GasH2S": this.PTWForm.value.GasTestedForH2S,
            "GasOxygen": this.PTWForm.value.GasTestedForO2,
            "Other": this.PTWForm.value.GasTestedForOther ? this.PTWForm.value.GasTestSpecify : "",
            "VehicleEntryRequired": this.PTWForm.value.IsVehicleRequired,
            "VehicleAccessPlanApproved": this.PTWForm.value.IsVehicleApproved,
            "PermittedVehicleType": this.PTWForm.value.VehicleType,
            "PermittedVehicleLocation": this.PTWForm.value.Location,
            "AgreesFrozenPlan": this.PTWForm.value.IsAgreeFrozenPlan,
            "ApplicantName": this.loggedInUserJSON.UserId,
            "ApplicantContractor": this.PTWForm.value.ContractorName.UserId,
            "PermitDurationFrom": this.PTWForm.value.DateFrom,
            "PermitDurationTo": this.PTWForm.value.DateTo,
            "WorkExaminationFirstDay": this.PTWForm.value.IsWorkExaminationFirstDay,
            "ValidatorEveryday": this.PTWForm.value.IsValidatorEveryday,
            "CreatedDate": moment(moment.utc(this.currentDate)).toDate(),
            "CreatedBy": this.loggedInUserJSON.UserId,
            "ModifiedDate": moment(moment.utc(this.currentDate)).toDate(),
            "ModifiedBy": this.loggedInUserJSON.UserId,
            "oncomingHolders": this.PTWForm.value.oncomingHolders ? this.PTWForm.value.oncomingHolders : [0],
            "SafetyEnvironmentPlan": this.SafetyEnvironmentPlanFiles,
            "VehicleEntryChecklist": this.VehicleEntryChecklistFiles,
            "IsDraft":true,
            "ContractId" :this.isEmployeeUnit?0:(this.PTWForm.get('Contract').value ? this.PTWForm.get('Contract').value : 0)
          },
          Certificates: this.Certificates
        }
      };
      this.PTWService.savePTWRequests(apiRequest, this.callbackMethodForSavePTWRequests.bind(this));
    }
    else {
      this.baseService.showRootLoader = false;
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "something went wrong!Please fill in all Mandatory fields"
      );
    }
  }
  //EOC Pritesh

   //BOC Pritesh
   ReportshowDialog() {
    
    this.ReportUserId = this.loggedInUserJSON.UserId;
    this.ReportModule = "PTW";
    this.ReportRecordId = this.permitId;
    this.ReportProcessId = 0;
    this.dialog1Height = (window.innerHeight - 50).toString() + "px";
    this.dialog1Width = window.innerWidth.toString() + "px";
    this.ReportclosePopup = true;
  }
  ReportclosePopUp() {
    this.ReportclosePopup = false;
  }
  //EOC Pritesh

  DisableRecordsEditedPropertyForTableData()
  {
    this.IsPTWOAFRecordsEdited = false;
    this.IsPTWSafetyRecordsEdited  = false;
    this.IsPTWValidationRecordsEdited  = false;
    this.IsPTWAcceptanceRecordsEdited  = false;
    this.IsPTWSuspensionRecordsEdited  = false;
    this.IsPTWTRICRecordsEdited = false;
  }
  getFormattedDate(date)
  {
    var diffinMin=date.getTimezoneOffset()*-1;
    date.setMinutes(date.getMinutes() + diffinMin);
    var dd   = date.getUTCDate();
    var mm   = date.getUTCMonth()+1;
    var yyyy = date.getUTCFullYear();
    var hour = date.getUTCHours();
    var minu = date.getUTCMinutes();

    if(dd<10)  { dd='0'+dd } 
    if(mm<10)  { mm='0'+mm } 
    if(minu<10){ minu='0'+minu } 

    return dd +'/'+mm+'/'+yyyy;
  }

  getFormattedDateTime(date)
  {
    var diffinMin=date.getTimezoneOffset()*-1;
    date.setMinutes(date.getMinutes() + diffinMin);
    var dd   = date.getUTCDate();
    var mm   = date.getUTCMonth()+1;
    var yyyy = date.getUTCFullYear();
    var hour = date.getUTCHours();
    var minu = date.getUTCMinutes();

    if(dd<10)  { dd='0'+dd } 
    if(mm<10)  { mm='0'+mm } 
    if(minu<10){ minu='0'+minu } 

    return dd +'/'+mm+'/'+yyyy+' '+hour+':'+minu;
  }


}
